export const example_grid = {
  cells: [
    {
      x: 0,
      y: 0,
      type: 'TEXT',
      value: 'Quadratic',
      last_modified: '2022-07-06T17:28:26.983Z',
    },
    {
      x: 0,
      y: 1,
      type: 'TEXT',
      value: 'The data science spreadsheet',
      last_modified: '2022-07-06T17:28:38.463Z',
    },
    {
      x: 0,
      y: 2,
      type: 'TEXT',
      value: 'Read more docs.quadratic.to',
      last_modified: '2022-07-06T17:32:01.914Z',
    },
    {
      x: 0,
      y: 5,
      type: 'TEXT',
      value: 'Python Examples',
      last_modified: '2022-07-06T17:02:54.480Z',
    },
    {
      x: 0,
      y: 7,
      type: 'PYTHON',
      value: 'Double click to see the code in an existing cell',
      python_code:
        'print("Hello world!")\n# The last python statement is returned\n# as the cell value.\n"Double click to see the code in an existing cell"\n',
      last_modified: '2022-07-06T17:32:12.049Z',
      python_output: 'Hello world!\n',
      array_cells: [],
      dependent_cells: [],
    },
    {
      x: 0,
      y: 9,
      type: 'PYTHON',
      value: 'Reference other cells',
      python_code:
        '# Reference a cell with c(x, y)\n# You can see the selected cell coordinates\n# in the bottom left bar.\nprint(c(3, 9))\n\n"Reference other cells"\n',
      last_modified: '2022-07-06T17:18:52.853Z',
      python_output: 'Ex Data\n',
      array_cells: [],
      dependent_cells: [[3, 9]],
    },
    {
      x: 0,
      y: 11,
      type: 'TEXT',
      value: 'Cell math',
      last_modified: '2022-07-06T17:06:41.183Z',
    },
    {
      x: 0,
      y: 12,
      type: 'TEXT',
      value: 'Cell eqality',
      last_modified: '2022-07-06T17:06:52.342Z',
    },
    {
      x: 0,
      y: 14,
      type: 'TEXT',
      value: 'Return a list of data',
      last_modified: '2022-07-06T17:18:46.883Z',
    },
    {
      x: 0,
      y: 15,
      type: 'PYTHON',
      value: '1',
      python_code:
        '# Returns the first 500 powers of 2\n# Try changing 2 to a larger number to see how\n# fast Quadratic is.\n# Pinch to zoom out and see the whole result.\nresult = []\nfor i in range(500):\n    result.append(2**i)\n',
      last_modified: '2022-07-06T17:30:08.174Z',
      python_output: '',
      array_cells: [
        [0, 15],
        [0, 16],
        [0, 17],
        [0, 18],
        [0, 19],
        [0, 20],
        [0, 21],
        [0, 22],
        [0, 23],
        [0, 24],
        [0, 25],
        [0, 26],
        [0, 27],
        [0, 28],
        [0, 29],
        [0, 30],
        [0, 31],
        [0, 32],
        [0, 33],
        [0, 34],
        [0, 35],
        [0, 36],
        [0, 37],
        [0, 38],
        [0, 39],
        [0, 40],
        [0, 41],
        [0, 42],
        [0, 43],
        [0, 44],
        [0, 45],
        [0, 46],
        [0, 47],
        [0, 48],
        [0, 49],
        [0, 50],
        [0, 51],
        [0, 52],
        [0, 53],
        [0, 54],
        [0, 55],
        [0, 56],
        [0, 57],
        [0, 58],
        [0, 59],
        [0, 60],
        [0, 61],
        [0, 62],
        [0, 63],
        [0, 64],
        [0, 65],
        [0, 66],
        [0, 67],
        [0, 68],
        [0, 69],
        [0, 70],
        [0, 71],
        [0, 72],
        [0, 73],
        [0, 74],
        [0, 75],
        [0, 76],
        [0, 77],
        [0, 78],
        [0, 79],
        [0, 80],
        [0, 81],
        [0, 82],
        [0, 83],
        [0, 84],
        [0, 85],
        [0, 86],
        [0, 87],
        [0, 88],
        [0, 89],
        [0, 90],
        [0, 91],
        [0, 92],
        [0, 93],
        [0, 94],
        [0, 95],
        [0, 96],
        [0, 97],
        [0, 98],
        [0, 99],
        [0, 100],
        [0, 101],
        [0, 102],
        [0, 103],
        [0, 104],
        [0, 105],
        [0, 106],
        [0, 107],
        [0, 108],
        [0, 109],
        [0, 110],
        [0, 111],
        [0, 112],
        [0, 113],
        [0, 114],
        [0, 115],
        [0, 116],
        [0, 117],
        [0, 118],
        [0, 119],
        [0, 120],
        [0, 121],
        [0, 122],
        [0, 123],
        [0, 124],
        [0, 125],
        [0, 126],
        [0, 127],
        [0, 128],
        [0, 129],
        [0, 130],
        [0, 131],
        [0, 132],
        [0, 133],
        [0, 134],
        [0, 135],
        [0, 136],
        [0, 137],
        [0, 138],
        [0, 139],
        [0, 140],
        [0, 141],
        [0, 142],
        [0, 143],
        [0, 144],
        [0, 145],
        [0, 146],
        [0, 147],
        [0, 148],
        [0, 149],
        [0, 150],
        [0, 151],
        [0, 152],
        [0, 153],
        [0, 154],
        [0, 155],
        [0, 156],
        [0, 157],
        [0, 158],
        [0, 159],
        [0, 160],
        [0, 161],
        [0, 162],
        [0, 163],
        [0, 164],
        [0, 165],
        [0, 166],
        [0, 167],
        [0, 168],
        [0, 169],
        [0, 170],
        [0, 171],
        [0, 172],
        [0, 173],
        [0, 174],
        [0, 175],
        [0, 176],
        [0, 177],
        [0, 178],
        [0, 179],
        [0, 180],
        [0, 181],
        [0, 182],
        [0, 183],
        [0, 184],
        [0, 185],
        [0, 186],
        [0, 187],
        [0, 188],
        [0, 189],
        [0, 190],
        [0, 191],
        [0, 192],
        [0, 193],
        [0, 194],
        [0, 195],
        [0, 196],
        [0, 197],
        [0, 198],
        [0, 199],
        [0, 200],
        [0, 201],
        [0, 202],
        [0, 203],
        [0, 204],
        [0, 205],
        [0, 206],
        [0, 207],
        [0, 208],
        [0, 209],
        [0, 210],
        [0, 211],
        [0, 212],
        [0, 213],
        [0, 214],
        [0, 215],
        [0, 216],
        [0, 217],
        [0, 218],
        [0, 219],
        [0, 220],
        [0, 221],
        [0, 222],
        [0, 223],
        [0, 224],
        [0, 225],
        [0, 226],
        [0, 227],
        [0, 228],
        [0, 229],
        [0, 230],
        [0, 231],
        [0, 232],
        [0, 233],
        [0, 234],
        [0, 235],
        [0, 236],
        [0, 237],
        [0, 238],
        [0, 239],
        [0, 240],
        [0, 241],
        [0, 242],
        [0, 243],
        [0, 244],
        [0, 245],
        [0, 246],
        [0, 247],
        [0, 248],
        [0, 249],
        [0, 250],
        [0, 251],
        [0, 252],
        [0, 253],
        [0, 254],
        [0, 255],
        [0, 256],
        [0, 257],
        [0, 258],
        [0, 259],
        [0, 260],
        [0, 261],
        [0, 262],
        [0, 263],
        [0, 264],
        [0, 265],
        [0, 266],
        [0, 267],
        [0, 268],
        [0, 269],
        [0, 270],
        [0, 271],
        [0, 272],
        [0, 273],
        [0, 274],
        [0, 275],
        [0, 276],
        [0, 277],
        [0, 278],
        [0, 279],
        [0, 280],
        [0, 281],
        [0, 282],
        [0, 283],
        [0, 284],
        [0, 285],
        [0, 286],
        [0, 287],
        [0, 288],
        [0, 289],
        [0, 290],
        [0, 291],
        [0, 292],
        [0, 293],
        [0, 294],
        [0, 295],
        [0, 296],
        [0, 297],
        [0, 298],
        [0, 299],
        [0, 300],
        [0, 301],
        [0, 302],
        [0, 303],
        [0, 304],
        [0, 305],
        [0, 306],
        [0, 307],
        [0, 308],
        [0, 309],
        [0, 310],
        [0, 311],
        [0, 312],
        [0, 313],
        [0, 314],
        [0, 315],
        [0, 316],
        [0, 317],
        [0, 318],
        [0, 319],
        [0, 320],
        [0, 321],
        [0, 322],
        [0, 323],
        [0, 324],
        [0, 325],
        [0, 326],
        [0, 327],
        [0, 328],
        [0, 329],
        [0, 330],
        [0, 331],
        [0, 332],
        [0, 333],
        [0, 334],
        [0, 335],
        [0, 336],
        [0, 337],
        [0, 338],
        [0, 339],
        [0, 340],
        [0, 341],
        [0, 342],
        [0, 343],
        [0, 344],
        [0, 345],
        [0, 346],
        [0, 347],
        [0, 348],
        [0, 349],
        [0, 350],
        [0, 351],
        [0, 352],
        [0, 353],
        [0, 354],
        [0, 355],
        [0, 356],
        [0, 357],
        [0, 358],
        [0, 359],
        [0, 360],
        [0, 361],
        [0, 362],
        [0, 363],
        [0, 364],
        [0, 365],
        [0, 366],
        [0, 367],
        [0, 368],
        [0, 369],
        [0, 370],
        [0, 371],
        [0, 372],
        [0, 373],
        [0, 374],
        [0, 375],
        [0, 376],
        [0, 377],
        [0, 378],
        [0, 379],
        [0, 380],
        [0, 381],
        [0, 382],
        [0, 383],
        [0, 384],
        [0, 385],
        [0, 386],
        [0, 387],
        [0, 388],
        [0, 389],
        [0, 390],
        [0, 391],
        [0, 392],
        [0, 393],
        [0, 394],
        [0, 395],
        [0, 396],
        [0, 397],
        [0, 398],
        [0, 399],
        [0, 400],
        [0, 401],
        [0, 402],
        [0, 403],
        [0, 404],
        [0, 405],
        [0, 406],
        [0, 407],
        [0, 408],
        [0, 409],
        [0, 410],
        [0, 411],
        [0, 412],
        [0, 413],
        [0, 414],
        [0, 415],
        [0, 416],
        [0, 417],
        [0, 418],
        [0, 419],
        [0, 420],
        [0, 421],
        [0, 422],
        [0, 423],
        [0, 424],
        [0, 425],
        [0, 426],
        [0, 427],
        [0, 428],
        [0, 429],
        [0, 430],
        [0, 431],
        [0, 432],
        [0, 433],
        [0, 434],
        [0, 435],
        [0, 436],
        [0, 437],
        [0, 438],
        [0, 439],
        [0, 440],
        [0, 441],
        [0, 442],
        [0, 443],
        [0, 444],
        [0, 445],
        [0, 446],
        [0, 447],
        [0, 448],
        [0, 449],
        [0, 450],
        [0, 451],
        [0, 452],
        [0, 453],
        [0, 454],
        [0, 455],
        [0, 456],
        [0, 457],
        [0, 458],
        [0, 459],
        [0, 460],
        [0, 461],
        [0, 462],
        [0, 463],
        [0, 464],
        [0, 465],
        [0, 466],
        [0, 467],
        [0, 468],
        [0, 469],
        [0, 470],
        [0, 471],
        [0, 472],
        [0, 473],
        [0, 474],
        [0, 475],
        [0, 476],
        [0, 477],
        [0, 478],
        [0, 479],
        [0, 480],
        [0, 481],
        [0, 482],
        [0, 483],
        [0, 484],
        [0, 485],
        [0, 486],
        [0, 487],
        [0, 488],
        [0, 489],
        [0, 490],
        [0, 491],
        [0, 492],
        [0, 493],
        [0, 494],
        [0, 495],
        [0, 496],
        [0, 497],
        [0, 498],
        [0, 499],
        [0, 500],
        [0, 501],
        [0, 502],
        [0, 503],
        [0, 504],
        [0, 505],
        [0, 506],
        [0, 507],
        [0, 508],
        [0, 509],
        [0, 510],
        [0, 511],
        [0, 512],
        [0, 513],
        [0, 514],
      ],
    },
    {
      x: 0,
      y: 16,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 17,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 18,
      type: 'COMPUTED',
      value: '8',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 19,
      type: 'COMPUTED',
      value: '16',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 20,
      type: 'COMPUTED',
      value: '32',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 21,
      type: 'COMPUTED',
      value: '64',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 22,
      type: 'COMPUTED',
      value: '128',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 23,
      type: 'COMPUTED',
      value: '256',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 24,
      type: 'COMPUTED',
      value: '512',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 25,
      type: 'COMPUTED',
      value: '1024',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 26,
      type: 'COMPUTED',
      value: '2048',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 27,
      type: 'COMPUTED',
      value: '4096',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 28,
      type: 'COMPUTED',
      value: '8192',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 29,
      type: 'COMPUTED',
      value: '16384',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 30,
      type: 'COMPUTED',
      value: '32768',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 31,
      type: 'COMPUTED',
      value: '65536',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 32,
      type: 'COMPUTED',
      value: '131072',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 33,
      type: 'COMPUTED',
      value: '262144',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 34,
      type: 'COMPUTED',
      value: '524288',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 35,
      type: 'COMPUTED',
      value: '1048576',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 36,
      type: 'COMPUTED',
      value: '2097152',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 37,
      type: 'COMPUTED',
      value: '4194304',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 38,
      type: 'COMPUTED',
      value: '8388608',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 39,
      type: 'COMPUTED',
      value: '16777216',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 40,
      type: 'COMPUTED',
      value: '33554432',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 41,
      type: 'COMPUTED',
      value: '67108864',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 42,
      type: 'COMPUTED',
      value: '134217728',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 43,
      type: 'COMPUTED',
      value: '268435456',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 44,
      type: 'COMPUTED',
      value: '536870912',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 45,
      type: 'COMPUTED',
      value: '1073741824',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 46,
      type: 'COMPUTED',
      value: '2147483648',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 47,
      type: 'COMPUTED',
      value: '4294967296',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 48,
      type: 'COMPUTED',
      value: '8589934592',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 49,
      type: 'COMPUTED',
      value: '17179869184',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 50,
      type: 'COMPUTED',
      value: '34359738368',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 51,
      type: 'COMPUTED',
      value: '68719476736',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 52,
      type: 'COMPUTED',
      value: '137438953472',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 53,
      type: 'COMPUTED',
      value: '274877906944',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 54,
      type: 'COMPUTED',
      value: '549755813888',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 55,
      type: 'COMPUTED',
      value: '1099511627776',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 56,
      type: 'COMPUTED',
      value: '2199023255552',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 57,
      type: 'COMPUTED',
      value: '4398046511104',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 58,
      type: 'COMPUTED',
      value: '8796093022208',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 59,
      type: 'COMPUTED',
      value: '17592186044416',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 60,
      type: 'COMPUTED',
      value: '35184372088832',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 61,
      type: 'COMPUTED',
      value: '70368744177664',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 62,
      type: 'COMPUTED',
      value: '140737488355328',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 63,
      type: 'COMPUTED',
      value: '281474976710656',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 64,
      type: 'COMPUTED',
      value: '562949953421312',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 65,
      type: 'COMPUTED',
      value: '1125899906842624',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 66,
      type: 'COMPUTED',
      value: '2251799813685248',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 67,
      type: 'COMPUTED',
      value: '4503599627370496',
      last_modified: '2022-07-06T17:30:08.173Z',
    },
    {
      x: 0,
      y: 68,
      type: 'COMPUTED',
      value: '9007199254740992',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 69,
      type: 'COMPUTED',
      value: '18014398509481984',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 70,
      type: 'COMPUTED',
      value: '36028797018963968',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 71,
      type: 'COMPUTED',
      value: '72057594037927936',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 72,
      type: 'COMPUTED',
      value: '144115188075855872',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 73,
      type: 'COMPUTED',
      value: '288230376151711744',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 74,
      type: 'COMPUTED',
      value: '576460752303423488',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 75,
      type: 'COMPUTED',
      value: '1152921504606846976',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 76,
      type: 'COMPUTED',
      value: '2305843009213693952',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 77,
      type: 'COMPUTED',
      value: '4611686018427387904',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 78,
      type: 'COMPUTED',
      value: '9223372036854775808',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 79,
      type: 'COMPUTED',
      value: '18446744073709551616',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 80,
      type: 'COMPUTED',
      value: '36893488147419103232',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 81,
      type: 'COMPUTED',
      value: '73786976294838206464',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 82,
      type: 'COMPUTED',
      value: '147573952589676412928',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 83,
      type: 'COMPUTED',
      value: '295147905179352825856',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 84,
      type: 'COMPUTED',
      value: '590295810358705651712',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 85,
      type: 'COMPUTED',
      value: '1180591620717411303424',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 86,
      type: 'COMPUTED',
      value: '2361183241434822606848',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 87,
      type: 'COMPUTED',
      value: '4722366482869645213696',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 88,
      type: 'COMPUTED',
      value: '9444732965739290427392',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 89,
      type: 'COMPUTED',
      value: '18889465931478580854784',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 90,
      type: 'COMPUTED',
      value: '37778931862957161709568',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 91,
      type: 'COMPUTED',
      value: '75557863725914323419136',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 92,
      type: 'COMPUTED',
      value: '151115727451828646838272',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 93,
      type: 'COMPUTED',
      value: '302231454903657293676544',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 94,
      type: 'COMPUTED',
      value: '604462909807314587353088',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 95,
      type: 'COMPUTED',
      value: '1208925819614629174706176',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 96,
      type: 'COMPUTED',
      value: '2417851639229258349412352',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 97,
      type: 'COMPUTED',
      value: '4835703278458516698824704',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 98,
      type: 'COMPUTED',
      value: '9671406556917033397649408',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 99,
      type: 'COMPUTED',
      value: '19342813113834066795298816',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 100,
      type: 'COMPUTED',
      value: '38685626227668133590597632',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 101,
      type: 'COMPUTED',
      value: '77371252455336267181195264',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 102,
      type: 'COMPUTED',
      value: '154742504910672534362390528',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 103,
      type: 'COMPUTED',
      value: '309485009821345068724781056',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 104,
      type: 'COMPUTED',
      value: '618970019642690137449562112',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 105,
      type: 'COMPUTED',
      value: '1237940039285380274899124224',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 106,
      type: 'COMPUTED',
      value: '2475880078570760549798248448',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 107,
      type: 'COMPUTED',
      value: '4951760157141521099596496896',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 108,
      type: 'COMPUTED',
      value: '9903520314283042199192993792',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 109,
      type: 'COMPUTED',
      value: '19807040628566084398385987584',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 110,
      type: 'COMPUTED',
      value: '39614081257132168796771975168',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 111,
      type: 'COMPUTED',
      value: '79228162514264337593543950336',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 112,
      type: 'COMPUTED',
      value: '158456325028528675187087900672',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 113,
      type: 'COMPUTED',
      value: '316912650057057350374175801344',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 114,
      type: 'COMPUTED',
      value: '633825300114114700748351602688',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 115,
      type: 'COMPUTED',
      value: '1267650600228229401496703205376',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 116,
      type: 'COMPUTED',
      value: '2535301200456458802993406410752',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 117,
      type: 'COMPUTED',
      value: '5070602400912917605986812821504',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 118,
      type: 'COMPUTED',
      value: '10141204801825835211973625643008',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 119,
      type: 'COMPUTED',
      value: '20282409603651670423947251286016',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 120,
      type: 'COMPUTED',
      value: '40564819207303340847894502572032',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 121,
      type: 'COMPUTED',
      value: '81129638414606681695789005144064',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 122,
      type: 'COMPUTED',
      value: '162259276829213363391578010288128',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 123,
      type: 'COMPUTED',
      value: '324518553658426726783156020576256',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 124,
      type: 'COMPUTED',
      value: '649037107316853453566312041152512',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 125,
      type: 'COMPUTED',
      value: '1298074214633706907132624082305024',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 126,
      type: 'COMPUTED',
      value: '2596148429267413814265248164610048',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 127,
      type: 'COMPUTED',
      value: '5192296858534827628530496329220096',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 128,
      type: 'COMPUTED',
      value: '10384593717069655257060992658440192',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 129,
      type: 'COMPUTED',
      value: '20769187434139310514121985316880384',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 130,
      type: 'COMPUTED',
      value: '41538374868278621028243970633760768',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 131,
      type: 'COMPUTED',
      value: '83076749736557242056487941267521536',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 132,
      type: 'COMPUTED',
      value: '166153499473114484112975882535043072',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 133,
      type: 'COMPUTED',
      value: '332306998946228968225951765070086144',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 134,
      type: 'COMPUTED',
      value: '664613997892457936451903530140172288',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 135,
      type: 'COMPUTED',
      value: '1329227995784915872903807060280344576',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 136,
      type: 'COMPUTED',
      value: '2658455991569831745807614120560689152',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 137,
      type: 'COMPUTED',
      value: '5316911983139663491615228241121378304',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 138,
      type: 'COMPUTED',
      value: '10633823966279326983230456482242756608',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 139,
      type: 'COMPUTED',
      value: '21267647932558653966460912964485513216',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 140,
      type: 'COMPUTED',
      value: '42535295865117307932921825928971026432',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 141,
      type: 'COMPUTED',
      value: '85070591730234615865843651857942052864',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 142,
      type: 'COMPUTED',
      value: '170141183460469231731687303715884105728',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 143,
      type: 'COMPUTED',
      value: '340282366920938463463374607431768211456',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 144,
      type: 'COMPUTED',
      value: '680564733841876926926749214863536422912',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 145,
      type: 'COMPUTED',
      value: '1361129467683753853853498429727072845824',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 146,
      type: 'COMPUTED',
      value: '2722258935367507707706996859454145691648',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 147,
      type: 'COMPUTED',
      value: '5444517870735015415413993718908291383296',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 148,
      type: 'COMPUTED',
      value: '10889035741470030830827987437816582766592',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 149,
      type: 'COMPUTED',
      value: '21778071482940061661655974875633165533184',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 150,
      type: 'COMPUTED',
      value: '43556142965880123323311949751266331066368',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 151,
      type: 'COMPUTED',
      value: '87112285931760246646623899502532662132736',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 152,
      type: 'COMPUTED',
      value: '174224571863520493293247799005065324265472',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 153,
      type: 'COMPUTED',
      value: '348449143727040986586495598010130648530944',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 154,
      type: 'COMPUTED',
      value: '696898287454081973172991196020261297061888',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 155,
      type: 'COMPUTED',
      value: '1393796574908163946345982392040522594123776',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 156,
      type: 'COMPUTED',
      value: '2787593149816327892691964784081045188247552',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 157,
      type: 'COMPUTED',
      value: '5575186299632655785383929568162090376495104',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 158,
      type: 'COMPUTED',
      value: '11150372599265311570767859136324180752990208',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 159,
      type: 'COMPUTED',
      value: '22300745198530623141535718272648361505980416',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 160,
      type: 'COMPUTED',
      value: '44601490397061246283071436545296723011960832',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 161,
      type: 'COMPUTED',
      value: '89202980794122492566142873090593446023921664',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 162,
      type: 'COMPUTED',
      value: '178405961588244985132285746181186892047843328',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 163,
      type: 'COMPUTED',
      value: '356811923176489970264571492362373784095686656',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 164,
      type: 'COMPUTED',
      value: '713623846352979940529142984724747568191373312',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 165,
      type: 'COMPUTED',
      value: '1427247692705959881058285969449495136382746624',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 166,
      type: 'COMPUTED',
      value: '2854495385411919762116571938898990272765493248',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 167,
      type: 'COMPUTED',
      value: '5708990770823839524233143877797980545530986496',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 168,
      type: 'COMPUTED',
      value: '11417981541647679048466287755595961091061972992',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 169,
      type: 'COMPUTED',
      value: '22835963083295358096932575511191922182123945984',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 170,
      type: 'COMPUTED',
      value: '45671926166590716193865151022383844364247891968',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 171,
      type: 'COMPUTED',
      value: '91343852333181432387730302044767688728495783936',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 172,
      type: 'COMPUTED',
      value: '182687704666362864775460604089535377456991567872',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 173,
      type: 'COMPUTED',
      value: '365375409332725729550921208179070754913983135744',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 174,
      type: 'COMPUTED',
      value: '730750818665451459101842416358141509827966271488',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 175,
      type: 'COMPUTED',
      value: '1461501637330902918203684832716283019655932542976',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 176,
      type: 'COMPUTED',
      value: '2923003274661805836407369665432566039311865085952',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 177,
      type: 'COMPUTED',
      value: '5846006549323611672814739330865132078623730171904',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 178,
      type: 'COMPUTED',
      value: '11692013098647223345629478661730264157247460343808',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 179,
      type: 'COMPUTED',
      value: '23384026197294446691258957323460528314494920687616',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 180,
      type: 'COMPUTED',
      value: '46768052394588893382517914646921056628989841375232',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 181,
      type: 'COMPUTED',
      value: '93536104789177786765035829293842113257979682750464',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 182,
      type: 'COMPUTED',
      value: '187072209578355573530071658587684226515959365500928',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 183,
      type: 'COMPUTED',
      value: '374144419156711147060143317175368453031918731001856',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 184,
      type: 'COMPUTED',
      value: '748288838313422294120286634350736906063837462003712',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 185,
      type: 'COMPUTED',
      value: '1496577676626844588240573268701473812127674924007424',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 186,
      type: 'COMPUTED',
      value: '2993155353253689176481146537402947624255349848014848',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 187,
      type: 'COMPUTED',
      value: '5986310706507378352962293074805895248510699696029696',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 188,
      type: 'COMPUTED',
      value: '11972621413014756705924586149611790497021399392059392',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 189,
      type: 'COMPUTED',
      value: '23945242826029513411849172299223580994042798784118784',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 190,
      type: 'COMPUTED',
      value: '47890485652059026823698344598447161988085597568237568',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 191,
      type: 'COMPUTED',
      value: '95780971304118053647396689196894323976171195136475136',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 192,
      type: 'COMPUTED',
      value: '191561942608236107294793378393788647952342390272950272',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 193,
      type: 'COMPUTED',
      value: '383123885216472214589586756787577295904684780545900544',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 194,
      type: 'COMPUTED',
      value: '766247770432944429179173513575154591809369561091801088',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 195,
      type: 'COMPUTED',
      value: '1532495540865888858358347027150309183618739122183602176',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 196,
      type: 'COMPUTED',
      value: '3064991081731777716716694054300618367237478244367204352',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 197,
      type: 'COMPUTED',
      value: '6129982163463555433433388108601236734474956488734408704',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 198,
      type: 'COMPUTED',
      value: '12259964326927110866866776217202473468949912977468817408',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 199,
      type: 'COMPUTED',
      value: '24519928653854221733733552434404946937899825954937634816',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 200,
      type: 'COMPUTED',
      value: '49039857307708443467467104868809893875799651909875269632',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 201,
      type: 'COMPUTED',
      value: '98079714615416886934934209737619787751599303819750539264',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 202,
      type: 'COMPUTED',
      value: '196159429230833773869868419475239575503198607639501078528',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 203,
      type: 'COMPUTED',
      value: '392318858461667547739736838950479151006397215279002157056',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 204,
      type: 'COMPUTED',
      value: '784637716923335095479473677900958302012794430558004314112',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 205,
      type: 'COMPUTED',
      value: '1569275433846670190958947355801916604025588861116008628224',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 206,
      type: 'COMPUTED',
      value: '3138550867693340381917894711603833208051177722232017256448',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 207,
      type: 'COMPUTED',
      value: '6277101735386680763835789423207666416102355444464034512896',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 208,
      type: 'COMPUTED',
      value: '12554203470773361527671578846415332832204710888928069025792',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 209,
      type: 'COMPUTED',
      value: '25108406941546723055343157692830665664409421777856138051584',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 210,
      type: 'COMPUTED',
      value: '50216813883093446110686315385661331328818843555712276103168',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 211,
      type: 'COMPUTED',
      value: '100433627766186892221372630771322662657637687111424552206336',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 212,
      type: 'COMPUTED',
      value: '200867255532373784442745261542645325315275374222849104412672',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 213,
      type: 'COMPUTED',
      value: '401734511064747568885490523085290650630550748445698208825344',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 214,
      type: 'COMPUTED',
      value: '803469022129495137770981046170581301261101496891396417650688',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 215,
      type: 'COMPUTED',
      value: '1606938044258990275541962092341162602522202993782792835301376',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 216,
      type: 'COMPUTED',
      value: '3213876088517980551083924184682325205044405987565585670602752',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 217,
      type: 'COMPUTED',
      value: '6427752177035961102167848369364650410088811975131171341205504',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 218,
      type: 'COMPUTED',
      value: '12855504354071922204335696738729300820177623950262342682411008',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 219,
      type: 'COMPUTED',
      value: '25711008708143844408671393477458601640355247900524685364822016',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 220,
      type: 'COMPUTED',
      value: '51422017416287688817342786954917203280710495801049370729644032',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 221,
      type: 'COMPUTED',
      value: '102844034832575377634685573909834406561420991602098741459288064',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 222,
      type: 'COMPUTED',
      value: '205688069665150755269371147819668813122841983204197482918576128',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 223,
      type: 'COMPUTED',
      value: '411376139330301510538742295639337626245683966408394965837152256',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 224,
      type: 'COMPUTED',
      value: '822752278660603021077484591278675252491367932816789931674304512',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 225,
      type: 'COMPUTED',
      value: '1645504557321206042154969182557350504982735865633579863348609024',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 226,
      type: 'COMPUTED',
      value: '3291009114642412084309938365114701009965471731267159726697218048',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 227,
      type: 'COMPUTED',
      value: '6582018229284824168619876730229402019930943462534319453394436096',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 228,
      type: 'COMPUTED',
      value: '13164036458569648337239753460458804039861886925068638906788872192',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 229,
      type: 'COMPUTED',
      value: '26328072917139296674479506920917608079723773850137277813577744384',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 230,
      type: 'COMPUTED',
      value: '52656145834278593348959013841835216159447547700274555627155488768',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 231,
      type: 'COMPUTED',
      value: '105312291668557186697918027683670432318895095400549111254310977536',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 232,
      type: 'COMPUTED',
      value: '210624583337114373395836055367340864637790190801098222508621955072',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 233,
      type: 'COMPUTED',
      value: '421249166674228746791672110734681729275580381602196445017243910144',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 234,
      type: 'COMPUTED',
      value: '842498333348457493583344221469363458551160763204392890034487820288',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 235,
      type: 'COMPUTED',
      value: '1684996666696914987166688442938726917102321526408785780068975640576',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 236,
      type: 'COMPUTED',
      value: '3369993333393829974333376885877453834204643052817571560137951281152',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 237,
      type: 'COMPUTED',
      value: '6739986666787659948666753771754907668409286105635143120275902562304',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 238,
      type: 'COMPUTED',
      value: '13479973333575319897333507543509815336818572211270286240551805124608',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 239,
      type: 'COMPUTED',
      value: '26959946667150639794667015087019630673637144422540572481103610249216',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 240,
      type: 'COMPUTED',
      value: '53919893334301279589334030174039261347274288845081144962207220498432',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 241,
      type: 'COMPUTED',
      value: '107839786668602559178668060348078522694548577690162289924414440996864',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 242,
      type: 'COMPUTED',
      value: '215679573337205118357336120696157045389097155380324579848828881993728',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 243,
      type: 'COMPUTED',
      value: '431359146674410236714672241392314090778194310760649159697657763987456',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 244,
      type: 'COMPUTED',
      value: '862718293348820473429344482784628181556388621521298319395315527974912',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 245,
      type: 'COMPUTED',
      value: '1725436586697640946858688965569256363112777243042596638790631055949824',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 246,
      type: 'COMPUTED',
      value: '3450873173395281893717377931138512726225554486085193277581262111899648',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 247,
      type: 'COMPUTED',
      value: '6901746346790563787434755862277025452451108972170386555162524223799296',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 248,
      type: 'COMPUTED',
      value: '13803492693581127574869511724554050904902217944340773110325048447598592',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 249,
      type: 'COMPUTED',
      value: '27606985387162255149739023449108101809804435888681546220650096895197184',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 250,
      type: 'COMPUTED',
      value: '55213970774324510299478046898216203619608871777363092441300193790394368',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 251,
      type: 'COMPUTED',
      value: '110427941548649020598956093796432407239217743554726184882600387580788736',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 252,
      type: 'COMPUTED',
      value: '220855883097298041197912187592864814478435487109452369765200775161577472',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 253,
      type: 'COMPUTED',
      value: '441711766194596082395824375185729628956870974218904739530401550323154944',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 254,
      type: 'COMPUTED',
      value: '883423532389192164791648750371459257913741948437809479060803100646309888',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 255,
      type: 'COMPUTED',
      value: '1766847064778384329583297500742918515827483896875618958121606201292619776',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 256,
      type: 'COMPUTED',
      value: '3533694129556768659166595001485837031654967793751237916243212402585239552',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 257,
      type: 'COMPUTED',
      value: '7067388259113537318333190002971674063309935587502475832486424805170479104',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 258,
      type: 'COMPUTED',
      value: '14134776518227074636666380005943348126619871175004951664972849610340958208',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 259,
      type: 'COMPUTED',
      value: '28269553036454149273332760011886696253239742350009903329945699220681916416',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 260,
      type: 'COMPUTED',
      value: '56539106072908298546665520023773392506479484700019806659891398441363832832',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 261,
      type: 'COMPUTED',
      value: '113078212145816597093331040047546785012958969400039613319782796882727665664',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 262,
      type: 'COMPUTED',
      value: '226156424291633194186662080095093570025917938800079226639565593765455331328',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 263,
      type: 'COMPUTED',
      value: '452312848583266388373324160190187140051835877600158453279131187530910662656',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 264,
      type: 'COMPUTED',
      value: '904625697166532776746648320380374280103671755200316906558262375061821325312',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 265,
      type: 'COMPUTED',
      value: '1809251394333065553493296640760748560207343510400633813116524750123642650624',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 266,
      type: 'COMPUTED',
      value: '3618502788666131106986593281521497120414687020801267626233049500247285301248',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 267,
      type: 'COMPUTED',
      value: '7237005577332262213973186563042994240829374041602535252466099000494570602496',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 268,
      type: 'COMPUTED',
      value: '14474011154664524427946373126085988481658748083205070504932198000989141204992',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 269,
      type: 'COMPUTED',
      value: '28948022309329048855892746252171976963317496166410141009864396001978282409984',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 270,
      type: 'COMPUTED',
      value: '57896044618658097711785492504343953926634992332820282019728792003956564819968',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 271,
      type: 'COMPUTED',
      value: '115792089237316195423570985008687907853269984665640564039457584007913129639936',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 272,
      type: 'COMPUTED',
      value: '231584178474632390847141970017375815706539969331281128078915168015826259279872',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 273,
      type: 'COMPUTED',
      value: '463168356949264781694283940034751631413079938662562256157830336031652518559744',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 274,
      type: 'COMPUTED',
      value: '926336713898529563388567880069503262826159877325124512315660672063305037119488',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 275,
      type: 'COMPUTED',
      value: '1852673427797059126777135760139006525652319754650249024631321344126610074238976',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 276,
      type: 'COMPUTED',
      value: '3705346855594118253554271520278013051304639509300498049262642688253220148477952',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 277,
      type: 'COMPUTED',
      value: '7410693711188236507108543040556026102609279018600996098525285376506440296955904',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 278,
      type: 'COMPUTED',
      value: '14821387422376473014217086081112052205218558037201992197050570753012880593911808',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 279,
      type: 'COMPUTED',
      value: '29642774844752946028434172162224104410437116074403984394101141506025761187823616',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 280,
      type: 'COMPUTED',
      value: '59285549689505892056868344324448208820874232148807968788202283012051522375647232',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 281,
      type: 'COMPUTED',
      value: '118571099379011784113736688648896417641748464297615937576404566024103044751294464',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 282,
      type: 'COMPUTED',
      value: '237142198758023568227473377297792835283496928595231875152809132048206089502588928',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 283,
      type: 'COMPUTED',
      value: '474284397516047136454946754595585670566993857190463750305618264096412179005177856',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 284,
      type: 'COMPUTED',
      value: '948568795032094272909893509191171341133987714380927500611236528192824358010355712',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 285,
      type: 'COMPUTED',
      value: '1897137590064188545819787018382342682267975428761855001222473056385648716020711424',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 286,
      type: 'COMPUTED',
      value: '3794275180128377091639574036764685364535950857523710002444946112771297432041422848',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 287,
      type: 'COMPUTED',
      value: '7588550360256754183279148073529370729071901715047420004889892225542594864082845696',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 288,
      type: 'COMPUTED',
      value: '15177100720513508366558296147058741458143803430094840009779784451085189728165691392',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 289,
      type: 'COMPUTED',
      value: '30354201441027016733116592294117482916287606860189680019559568902170379456331382784',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 290,
      type: 'COMPUTED',
      value: '60708402882054033466233184588234965832575213720379360039119137804340758912662765568',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 291,
      type: 'COMPUTED',
      value: '121416805764108066932466369176469931665150427440758720078238275608681517825325531136',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 292,
      type: 'COMPUTED',
      value: '242833611528216133864932738352939863330300854881517440156476551217363035650651062272',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 293,
      type: 'COMPUTED',
      value: '485667223056432267729865476705879726660601709763034880312953102434726071301302124544',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 294,
      type: 'COMPUTED',
      value: '971334446112864535459730953411759453321203419526069760625906204869452142602604249088',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 295,
      type: 'COMPUTED',
      value: '1942668892225729070919461906823518906642406839052139521251812409738904285205208498176',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 296,
      type: 'COMPUTED',
      value: '3885337784451458141838923813647037813284813678104279042503624819477808570410416996352',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 297,
      type: 'COMPUTED',
      value: '7770675568902916283677847627294075626569627356208558085007249638955617140820833992704',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 298,
      type: 'COMPUTED',
      value: '15541351137805832567355695254588151253139254712417116170014499277911234281641667985408',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 299,
      type: 'COMPUTED',
      value: '31082702275611665134711390509176302506278509424834232340028998555822468563283335970816',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 300,
      type: 'COMPUTED',
      value: '62165404551223330269422781018352605012557018849668464680057997111644937126566671941632',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 301,
      type: 'COMPUTED',
      value: '124330809102446660538845562036705210025114037699336929360115994223289874253133343883264',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 302,
      type: 'COMPUTED',
      value: '248661618204893321077691124073410420050228075398673858720231988446579748506266687766528',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 303,
      type: 'COMPUTED',
      value: '497323236409786642155382248146820840100456150797347717440463976893159497012533375533056',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 304,
      type: 'COMPUTED',
      value: '994646472819573284310764496293641680200912301594695434880927953786318994025066751066112',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 305,
      type: 'COMPUTED',
      value: '1989292945639146568621528992587283360401824603189390869761855907572637988050133502132224',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 306,
      type: 'COMPUTED',
      value: '3978585891278293137243057985174566720803649206378781739523711815145275976100267004264448',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 307,
      type: 'COMPUTED',
      value: '7957171782556586274486115970349133441607298412757563479047423630290551952200534008528896',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 308,
      type: 'COMPUTED',
      value: '15914343565113172548972231940698266883214596825515126958094847260581103904401068017057792',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 309,
      type: 'COMPUTED',
      value: '31828687130226345097944463881396533766429193651030253916189694521162207808802136034115584',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 310,
      type: 'COMPUTED',
      value: '63657374260452690195888927762793067532858387302060507832379389042324415617604272068231168',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 311,
      type: 'COMPUTED',
      value: '127314748520905380391777855525586135065716774604121015664758778084648831235208544136462336',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 312,
      type: 'COMPUTED',
      value: '254629497041810760783555711051172270131433549208242031329517556169297662470417088272924672',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 313,
      type: 'COMPUTED',
      value: '509258994083621521567111422102344540262867098416484062659035112338595324940834176545849344',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 314,
      type: 'COMPUTED',
      value: '1018517988167243043134222844204689080525734196832968125318070224677190649881668353091698688',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 315,
      type: 'COMPUTED',
      value: '2037035976334486086268445688409378161051468393665936250636140449354381299763336706183397376',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 316,
      type: 'COMPUTED',
      value: '4074071952668972172536891376818756322102936787331872501272280898708762599526673412366794752',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 317,
      type: 'COMPUTED',
      value: '8148143905337944345073782753637512644205873574663745002544561797417525199053346824733589504',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 318,
      type: 'COMPUTED',
      value: '16296287810675888690147565507275025288411747149327490005089123594835050398106693649467179008',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 319,
      type: 'COMPUTED',
      value: '32592575621351777380295131014550050576823494298654980010178247189670100796213387298934358016',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 320,
      type: 'COMPUTED',
      value: '65185151242703554760590262029100101153646988597309960020356494379340201592426774597868716032',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 321,
      type: 'COMPUTED',
      value: '130370302485407109521180524058200202307293977194619920040712988758680403184853549195737432064',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 322,
      type: 'COMPUTED',
      value: '260740604970814219042361048116400404614587954389239840081425977517360806369707098391474864128',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 323,
      type: 'COMPUTED',
      value: '521481209941628438084722096232800809229175908778479680162851955034721612739414196782949728256',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 324,
      type: 'COMPUTED',
      value: '1042962419883256876169444192465601618458351817556959360325703910069443225478828393565899456512',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 325,
      type: 'COMPUTED',
      value: '2085924839766513752338888384931203236916703635113918720651407820138886450957656787131798913024',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 326,
      type: 'COMPUTED',
      value: '4171849679533027504677776769862406473833407270227837441302815640277772901915313574263597826048',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 327,
      type: 'COMPUTED',
      value: '8343699359066055009355553539724812947666814540455674882605631280555545803830627148527195652096',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 328,
      type: 'COMPUTED',
      value: '16687398718132110018711107079449625895333629080911349765211262561111091607661254297054391304192',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 329,
      type: 'COMPUTED',
      value: '33374797436264220037422214158899251790667258161822699530422525122222183215322508594108782608384',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 330,
      type: 'COMPUTED',
      value: '66749594872528440074844428317798503581334516323645399060845050244444366430645017188217565216768',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 331,
      type: 'COMPUTED',
      value: '133499189745056880149688856635597007162669032647290798121690100488888732861290034376435130433536',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 332,
      type: 'COMPUTED',
      value: '266998379490113760299377713271194014325338065294581596243380200977777465722580068752870260867072',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 333,
      type: 'COMPUTED',
      value: '533996758980227520598755426542388028650676130589163192486760401955554931445160137505740521734144',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 334,
      type: 'COMPUTED',
      value: '1067993517960455041197510853084776057301352261178326384973520803911109862890320275011481043468288',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 335,
      type: 'COMPUTED',
      value: '2135987035920910082395021706169552114602704522356652769947041607822219725780640550022962086936576',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 336,
      type: 'COMPUTED',
      value: '4271974071841820164790043412339104229205409044713305539894083215644439451561281100045924173873152',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 337,
      type: 'COMPUTED',
      value: '8543948143683640329580086824678208458410818089426611079788166431288878903122562200091848347746304',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 338,
      type: 'COMPUTED',
      value: '17087896287367280659160173649356416916821636178853222159576332862577757806245124400183696695492608',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 339,
      type: 'COMPUTED',
      value: '34175792574734561318320347298712833833643272357706444319152665725155515612490248800367393390985216',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 340,
      type: 'COMPUTED',
      value: '68351585149469122636640694597425667667286544715412888638305331450311031224980497600734786781970432',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 341,
      type: 'COMPUTED',
      value: '136703170298938245273281389194851335334573089430825777276610662900622062449960995201469573563940864',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 342,
      type: 'COMPUTED',
      value: '273406340597876490546562778389702670669146178861651554553221325801244124899921990402939147127881728',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 343,
      type: 'COMPUTED',
      value: '546812681195752981093125556779405341338292357723303109106442651602488249799843980805878294255763456',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 344,
      type: 'COMPUTED',
      value: '1093625362391505962186251113558810682676584715446606218212885303204976499599687961611756588511526912',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 345,
      type: 'COMPUTED',
      value: '2187250724783011924372502227117621365353169430893212436425770606409952999199375923223513177023053824',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 346,
      type: 'COMPUTED',
      value: '4374501449566023848745004454235242730706338861786424872851541212819905998398751846447026354046107648',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 347,
      type: 'COMPUTED',
      value: '8749002899132047697490008908470485461412677723572849745703082425639811996797503692894052708092215296',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 348,
      type: 'COMPUTED',
      value: '17498005798264095394980017816940970922825355447145699491406164851279623993595007385788105416184430592',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 349,
      type: 'COMPUTED',
      value: '34996011596528190789960035633881941845650710894291398982812329702559247987190014771576210832368861184',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 350,
      type: 'COMPUTED',
      value: '69992023193056381579920071267763883691301421788582797965624659405118495974380029543152421664737722368',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 351,
      type: 'COMPUTED',
      value: '139984046386112763159840142535527767382602843577165595931249318810236991948760059086304843329475444736',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 352,
      type: 'COMPUTED',
      value: '279968092772225526319680285071055534765205687154331191862498637620473983897520118172609686658950889472',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 353,
      type: 'COMPUTED',
      value: '559936185544451052639360570142111069530411374308662383724997275240947967795040236345219373317901778944',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 354,
      type: 'COMPUTED',
      value: '1119872371088902105278721140284222139060822748617324767449994550481895935590080472690438746635803557888',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 355,
      type: 'COMPUTED',
      value: '2239744742177804210557442280568444278121645497234649534899989100963791871180160945380877493271607115776',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 356,
      type: 'COMPUTED',
      value: '4479489484355608421114884561136888556243290994469299069799978201927583742360321890761754986543214231552',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 357,
      type: 'COMPUTED',
      value: '8958978968711216842229769122273777112486581988938598139599956403855167484720643781523509973086428463104',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 358,
      type: 'COMPUTED',
      value: '17917957937422433684459538244547554224973163977877196279199912807710334969441287563047019946172856926208',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 359,
      type: 'COMPUTED',
      value: '35835915874844867368919076489095108449946327955754392558399825615420669938882575126094039892345713852416',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 360,
      type: 'COMPUTED',
      value: '71671831749689734737838152978190216899892655911508785116799651230841339877765150252188079784691427704832',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 361,
      type: 'COMPUTED',
      value:
        '143343663499379469475676305956380433799785311823017570233599302461682679755530300504376159569382855409664',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 362,
      type: 'COMPUTED',
      value:
        '286687326998758938951352611912760867599570623646035140467198604923365359511060601008752319138765710819328',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 363,
      type: 'COMPUTED',
      value:
        '573374653997517877902705223825521735199141247292070280934397209846730719022121202017504638277531421638656',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 364,
      type: 'COMPUTED',
      value:
        '1146749307995035755805410447651043470398282494584140561868794419693461438044242404035009276555062843277312',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 365,
      type: 'COMPUTED',
      value:
        '2293498615990071511610820895302086940796564989168281123737588839386922876088484808070018553110125686554624',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 366,
      type: 'COMPUTED',
      value:
        '4586997231980143023221641790604173881593129978336562247475177678773845752176969616140037106220251373109248',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 367,
      type: 'COMPUTED',
      value:
        '9173994463960286046443283581208347763186259956673124494950355357547691504353939232280074212440502746218496',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 368,
      type: 'COMPUTED',
      value:
        '18347988927920572092886567162416695526372519913346248989900710715095383008707878464560148424881005492436992',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 369,
      type: 'COMPUTED',
      value:
        '36695977855841144185773134324833391052745039826692497979801421430190766017415756929120296849762010984873984',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 370,
      type: 'COMPUTED',
      value:
        '73391955711682288371546268649666782105490079653384995959602842860381532034831513858240593699524021969747968',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 371,
      type: 'COMPUTED',
      value:
        '146783911423364576743092537299333564210980159306769991919205685720763064069663027716481187399048043939495936',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 372,
      type: 'COMPUTED',
      value:
        '293567822846729153486185074598667128421960318613539983838411371441526128139326055432962374798096087878991872',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 373,
      type: 'COMPUTED',
      value:
        '587135645693458306972370149197334256843920637227079967676822742883052256278652110865924749596192175757983744',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 374,
      type: 'COMPUTED',
      value:
        '1174271291386916613944740298394668513687841274454159935353645485766104512557304221731849499192384351515967488',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 375,
      type: 'COMPUTED',
      value:
        '2348542582773833227889480596789337027375682548908319870707290971532209025114608443463698998384768703031934976',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 376,
      type: 'COMPUTED',
      value:
        '4697085165547666455778961193578674054751365097816639741414581943064418050229216886927397996769537406063869952',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 377,
      type: 'COMPUTED',
      value:
        '9394170331095332911557922387157348109502730195633279482829163886128836100458433773854795993539074812127739904',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 378,
      type: 'COMPUTED',
      value:
        '18788340662190665823115844774314696219005460391266558965658327772257672200916867547709591987078149624255479808',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 379,
      type: 'COMPUTED',
      value:
        '37576681324381331646231689548629392438010920782533117931316655544515344401833735095419183974156299248510959616',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 380,
      type: 'COMPUTED',
      value:
        '75153362648762663292463379097258784876021841565066235862633311089030688803667470190838367948312598497021919232',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 381,
      type: 'COMPUTED',
      value:
        '150306725297525326584926758194517569752043683130132471725266622178061377607334940381676735896625196994043838464',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 382,
      type: 'COMPUTED',
      value:
        '300613450595050653169853516389035139504087366260264943450533244356122755214669880763353471793250393988087676928',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 383,
      type: 'COMPUTED',
      value:
        '601226901190101306339707032778070279008174732520529886901066488712245510429339761526706943586500787976175353856',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 384,
      type: 'COMPUTED',
      value:
        '1202453802380202612679414065556140558016349465041059773802132977424491020858679523053413887173001575952350707712',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 385,
      type: 'COMPUTED',
      value:
        '2404907604760405225358828131112281116032698930082119547604265954848982041717359046106827774346003151904701415424',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 386,
      type: 'COMPUTED',
      value:
        '4809815209520810450717656262224562232065397860164239095208531909697964083434718092213655548692006303809402830848',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 387,
      type: 'COMPUTED',
      value:
        '9619630419041620901435312524449124464130795720328478190417063819395928166869436184427311097384012607618805661696',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 388,
      type: 'COMPUTED',
      value:
        '19239260838083241802870625048898248928261591440656956380834127638791856333738872368854622194768025215237611323392',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 389,
      type: 'COMPUTED',
      value:
        '38478521676166483605741250097796497856523182881313912761668255277583712667477744737709244389536050430475222646784',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 390,
      type: 'COMPUTED',
      value:
        '76957043352332967211482500195592995713046365762627825523336510555167425334955489475418488779072100860950445293568',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 391,
      type: 'COMPUTED',
      value:
        '153914086704665934422965000391185991426092731525255651046673021110334850669910978950836977558144201721900890587136',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 392,
      type: 'COMPUTED',
      value:
        '307828173409331868845930000782371982852185463050511302093346042220669701339821957901673955116288403443801781174272',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 393,
      type: 'COMPUTED',
      value:
        '615656346818663737691860001564743965704370926101022604186692084441339402679643915803347910232576806887603562348544',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 394,
      type: 'COMPUTED',
      value:
        '1231312693637327475383720003129487931408741852202045208373384168882678805359287831606695820465153613775207124697088',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 395,
      type: 'COMPUTED',
      value:
        '2462625387274654950767440006258975862817483704404090416746768337765357610718575663213391640930307227550414249394176',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 396,
      type: 'COMPUTED',
      value:
        '4925250774549309901534880012517951725634967408808180833493536675530715221437151326426783281860614455100828498788352',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 397,
      type: 'COMPUTED',
      value:
        '9850501549098619803069760025035903451269934817616361666987073351061430442874302652853566563721228910201656997576704',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 398,
      type: 'COMPUTED',
      value:
        '19701003098197239606139520050071806902539869635232723333974146702122860885748605305707133127442457820403313995153408',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 399,
      type: 'COMPUTED',
      value:
        '39402006196394479212279040100143613805079739270465446667948293404245721771497210611414266254884915640806627990306816',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 400,
      type: 'COMPUTED',
      value:
        '78804012392788958424558080200287227610159478540930893335896586808491443542994421222828532509769831281613255980613632',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 401,
      type: 'COMPUTED',
      value:
        '157608024785577916849116160400574455220318957081861786671793173616982887085988842445657065019539662563226511961227264',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 402,
      type: 'COMPUTED',
      value:
        '315216049571155833698232320801148910440637914163723573343586347233965774171977684891314130039079325126453023922454528',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 403,
      type: 'COMPUTED',
      value:
        '630432099142311667396464641602297820881275828327447146687172694467931548343955369782628260078158650252906047844909056',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 404,
      type: 'COMPUTED',
      value:
        '1260864198284623334792929283204595641762551656654894293374345388935863096687910739565256520156317300505812095689818112',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 405,
      type: 'COMPUTED',
      value:
        '2521728396569246669585858566409191283525103313309788586748690777871726193375821479130513040312634601011624191379636224',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 406,
      type: 'COMPUTED',
      value:
        '5043456793138493339171717132818382567050206626619577173497381555743452386751642958261026080625269202023248382759272448',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 407,
      type: 'COMPUTED',
      value:
        '10086913586276986678343434265636765134100413253239154346994763111486904773503285916522052161250538404046496765518544896',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 408,
      type: 'COMPUTED',
      value:
        '20173827172553973356686868531273530268200826506478308693989526222973809547006571833044104322501076808092993531037089792',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 409,
      type: 'COMPUTED',
      value:
        '40347654345107946713373737062547060536401653012956617387979052445947619094013143666088208645002153616185987062074179584',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 410,
      type: 'COMPUTED',
      value:
        '80695308690215893426747474125094121072803306025913234775958104891895238188026287332176417290004307232371974124148359168',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 411,
      type: 'COMPUTED',
      value:
        '161390617380431786853494948250188242145606612051826469551916209783790476376052574664352834580008614464743948248296718336',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 412,
      type: 'COMPUTED',
      value:
        '322781234760863573706989896500376484291213224103652939103832419567580952752105149328705669160017228929487896496593436672',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 413,
      type: 'COMPUTED',
      value:
        '645562469521727147413979793000752968582426448207305878207664839135161905504210298657411338320034457858975792993186873344',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 414,
      type: 'COMPUTED',
      value:
        '1291124939043454294827959586001505937164852896414611756415329678270323811008420597314822676640068915717951585986373746688',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 415,
      type: 'COMPUTED',
      value:
        '2582249878086908589655919172003011874329705792829223512830659356540647622016841194629645353280137831435903171972747493376',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 416,
      type: 'COMPUTED',
      value:
        '5164499756173817179311838344006023748659411585658447025661318713081295244033682389259290706560275662871806343945494986752',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 417,
      type: 'COMPUTED',
      value:
        '10328999512347634358623676688012047497318823171316894051322637426162590488067364778518581413120551325743612687890989973504',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 418,
      type: 'COMPUTED',
      value:
        '20657999024695268717247353376024094994637646342633788102645274852325180976134729557037162826241102651487225375781979947008',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 419,
      type: 'COMPUTED',
      value:
        '41315998049390537434494706752048189989275292685267576205290549704650361952269459114074325652482205302974450751563959894016',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 420,
      type: 'COMPUTED',
      value:
        '82631996098781074868989413504096379978550585370535152410581099409300723904538918228148651304964410605948901503127919788032',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 421,
      type: 'COMPUTED',
      value:
        '165263992197562149737978827008192759957101170741070304821162198818601447809077836456297302609928821211897803006255839576064',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 422,
      type: 'COMPUTED',
      value:
        '330527984395124299475957654016385519914202341482140609642324397637202895618155672912594605219857642423795606012511679152128',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 423,
      type: 'COMPUTED',
      value:
        '661055968790248598951915308032771039828404682964281219284648795274405791236311345825189210439715284847591212025023358304256',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 424,
      type: 'COMPUTED',
      value:
        '1322111937580497197903830616065542079656809365928562438569297590548811582472622691650378420879430569695182424050046716608512',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 425,
      type: 'COMPUTED',
      value:
        '2644223875160994395807661232131084159313618731857124877138595181097623164945245383300756841758861139390364848100093433217024',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 426,
      type: 'COMPUTED',
      value:
        '5288447750321988791615322464262168318627237463714249754277190362195246329890490766601513683517722278780729696200186866434048',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 427,
      type: 'COMPUTED',
      value:
        '10576895500643977583230644928524336637254474927428499508554380724390492659780981533203027367035444557561459392400373732868096',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 428,
      type: 'COMPUTED',
      value:
        '21153791001287955166461289857048673274508949854856999017108761448780985319561963066406054734070889115122918784800747465736192',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 429,
      type: 'COMPUTED',
      value:
        '42307582002575910332922579714097346549017899709713998034217522897561970639123926132812109468141778230245837569601494931472384',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 430,
      type: 'COMPUTED',
      value:
        '84615164005151820665845159428194693098035799419427996068435045795123941278247852265624218936283556460491675139202989862944768',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 431,
      type: 'COMPUTED',
      value:
        '169230328010303641331690318856389386196071598838855992136870091590247882556495704531248437872567112920983350278405979725889536',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 432,
      type: 'COMPUTED',
      value:
        '338460656020607282663380637712778772392143197677711984273740183180495765112991409062496875745134225841966700556811959451779072',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 433,
      type: 'COMPUTED',
      value:
        '676921312041214565326761275425557544784286395355423968547480366360991530225982818124993751490268451683933401113623918903558144',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 434,
      type: 'COMPUTED',
      value:
        '1353842624082429130653522550851115089568572790710847937094960732721983060451965636249987502980536903367866802227247837807116288',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 435,
      type: 'COMPUTED',
      value:
        '2707685248164858261307045101702230179137145581421695874189921465443966120903931272499975005961073806735733604454495675614232576',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 436,
      type: 'COMPUTED',
      value:
        '5415370496329716522614090203404460358274291162843391748379842930887932241807862544999950011922147613471467208908991351228465152',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 437,
      type: 'COMPUTED',
      value:
        '10830740992659433045228180406808920716548582325686783496759685861775864483615725089999900023844295226942934417817982702456930304',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 438,
      type: 'COMPUTED',
      value:
        '21661481985318866090456360813617841433097164651373566993519371723551728967231450179999800047688590453885868835635965404913860608',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 439,
      type: 'COMPUTED',
      value:
        '43322963970637732180912721627235682866194329302747133987038743447103457934462900359999600095377180907771737671271930809827721216',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 440,
      type: 'COMPUTED',
      value:
        '86645927941275464361825443254471365732388658605494267974077486894206915868925800719999200190754361815543475342543861619655442432',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 441,
      type: 'COMPUTED',
      value:
        '173291855882550928723650886508942731464777317210988535948154973788413831737851601439998400381508723631086950685087723239310884864',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 442,
      type: 'COMPUTED',
      value:
        '346583711765101857447301773017885462929554634421977071896309947576827663475703202879996800763017447262173901370175446478621769728',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 443,
      type: 'COMPUTED',
      value:
        '693167423530203714894603546035770925859109268843954143792619895153655326951406405759993601526034894524347802740350892957243539456',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 444,
      type: 'COMPUTED',
      value:
        '1386334847060407429789207092071541851718218537687908287585239790307310653902812811519987203052069789048695605480701785914487078912',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 445,
      type: 'COMPUTED',
      value:
        '2772669694120814859578414184143083703436437075375816575170479580614621307805625623039974406104139578097391210961403571828974157824',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 446,
      type: 'COMPUTED',
      value:
        '5545339388241629719156828368286167406872874150751633150340959161229242615611251246079948812208279156194782421922807143657948315648',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 447,
      type: 'COMPUTED',
      value:
        '11090678776483259438313656736572334813745748301503266300681918322458485231222502492159897624416558312389564843845614287315896631296',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 448,
      type: 'COMPUTED',
      value:
        '22181357552966518876627313473144669627491496603006532601363836644916970462445004984319795248833116624779129687691228574631793262592',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 449,
      type: 'COMPUTED',
      value:
        '44362715105933037753254626946289339254982993206013065202727673289833940924890009968639590497666233249558259375382457149263586525184',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 450,
      type: 'COMPUTED',
      value:
        '88725430211866075506509253892578678509965986412026130405455346579667881849780019937279180995332466499116518750764914298527173050368',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 451,
      type: 'COMPUTED',
      value:
        '177450860423732151013018507785157357019931972824052260810910693159335763699560039874558361990664932998233037501529828597054346100736',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 452,
      type: 'COMPUTED',
      value:
        '354901720847464302026037015570314714039863945648104521621821386318671527399120079749116723981329865996466075003059657194108692201472',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 453,
      type: 'COMPUTED',
      value:
        '709803441694928604052074031140629428079727891296209043243642772637343054798240159498233447962659731992932150006119314388217384402944',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 454,
      type: 'COMPUTED',
      value:
        '1419606883389857208104148062281258856159455782592418086487285545274686109596480318996466895925319463985864300012238628776434768805888',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 455,
      type: 'COMPUTED',
      value:
        '2839213766779714416208296124562517712318911565184836172974571090549372219192960637992933791850638927971728600024477257552869537611776',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 456,
      type: 'COMPUTED',
      value:
        '5678427533559428832416592249125035424637823130369672345949142181098744438385921275985867583701277855943457200048954515105739075223552',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 457,
      type: 'COMPUTED',
      value:
        '11356855067118857664833184498250070849275646260739344691898284362197488876771842551971735167402555711886914400097909030211478150447104',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 458,
      type: 'COMPUTED',
      value:
        '22713710134237715329666368996500141698551292521478689383796568724394977753543685103943470334805111423773828800195818060422956300894208',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 459,
      type: 'COMPUTED',
      value:
        '45427420268475430659332737993000283397102585042957378767593137448789955507087370207886940669610222847547657600391636120845912601788416',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 460,
      type: 'COMPUTED',
      value:
        '90854840536950861318665475986000566794205170085914757535186274897579911014174740415773881339220445695095315200783272241691825203576832',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 461,
      type: 'COMPUTED',
      value:
        '181709681073901722637330951972001133588410340171829515070372549795159822028349480831547762678440891390190630401566544483383650407153664',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 462,
      type: 'COMPUTED',
      value:
        '363419362147803445274661903944002267176820680343659030140745099590319644056698961663095525356881782780381260803133088966767300814307328',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 463,
      type: 'COMPUTED',
      value:
        '726838724295606890549323807888004534353641360687318060281490199180639288113397923326191050713763565560762521606266177933534601628614656',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 464,
      type: 'COMPUTED',
      value:
        '1453677448591213781098647615776009068707282721374636120562980398361278576226795846652382101427527131121525043212532355867069203257229312',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 465,
      type: 'COMPUTED',
      value:
        '2907354897182427562197295231552018137414565442749272241125960796722557152453591693304764202855054262243050086425064711734138406514458624',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 466,
      type: 'COMPUTED',
      value:
        '5814709794364855124394590463104036274829130885498544482251921593445114304907183386609528405710108524486100172850129423468276813028917248',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 467,
      type: 'COMPUTED',
      value:
        '11629419588729710248789180926208072549658261770997088964503843186890228609814366773219056811420217048972200345700258846936553626057834496',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 468,
      type: 'COMPUTED',
      value:
        '23258839177459420497578361852416145099316523541994177929007686373780457219628733546438113622840434097944400691400517693873107252115668992',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 469,
      type: 'COMPUTED',
      value:
        '46517678354918840995156723704832290198633047083988355858015372747560914439257467092876227245680868195888801382801035387746214504231337984',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 470,
      type: 'COMPUTED',
      value:
        '93035356709837681990313447409664580397266094167976711716030745495121828878514934185752454491361736391777602765602070775492429008462675968',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 471,
      type: 'COMPUTED',
      value:
        '186070713419675363980626894819329160794532188335953423432061490990243657757029868371504908982723472783555205531204141550984858016925351936',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 472,
      type: 'COMPUTED',
      value:
        '372141426839350727961253789638658321589064376671906846864122981980487315514059736743009817965446945567110411062408283101969716033850703872',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 473,
      type: 'COMPUTED',
      value:
        '744282853678701455922507579277316643178128753343813693728245963960974631028119473486019635930893891134220822124816566203939432067701407744',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 474,
      type: 'COMPUTED',
      value:
        '1488565707357402911845015158554633286356257506687627387456491927921949262056238946972039271861787782268441644249633132407878864135402815488',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 475,
      type: 'COMPUTED',
      value:
        '2977131414714805823690030317109266572712515013375254774912983855843898524112477893944078543723575564536883288499266264815757728270805630976',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 476,
      type: 'COMPUTED',
      value:
        '5954262829429611647380060634218533145425030026750509549825967711687797048224955787888157087447151129073766576998532529631515456541611261952',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 477,
      type: 'COMPUTED',
      value:
        '11908525658859223294760121268437066290850060053501019099651935423375594096449911575776314174894302258147533153997065059263030913083222523904',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 478,
      type: 'COMPUTED',
      value:
        '23817051317718446589520242536874132581700120107002038199303870846751188192899823151552628349788604516295066307994130118526061826166445047808',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 479,
      type: 'COMPUTED',
      value:
        '47634102635436893179040485073748265163400240214004076398607741693502376385799646303105256699577209032590132615988260237052123652332890095616',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 480,
      type: 'COMPUTED',
      value:
        '95268205270873786358080970147496530326800480428008152797215483387004752771599292606210513399154418065180265231976520474104247304665780191232',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 481,
      type: 'COMPUTED',
      value:
        '190536410541747572716161940294993060653600960856016305594430966774009505543198585212421026798308836130360530463953040948208494609331560382464',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 482,
      type: 'COMPUTED',
      value:
        '381072821083495145432323880589986121307201921712032611188861933548019011086397170424842053596617672260721060927906081896416989218663120764928',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 483,
      type: 'COMPUTED',
      value:
        '762145642166990290864647761179972242614403843424065222377723867096038022172794340849684107193235344521442121855812163792833978437326241529856',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 484,
      type: 'COMPUTED',
      value:
        '1524291284333980581729295522359944485228807686848130444755447734192076044345588681699368214386470689042884243711624327585667956874652483059712',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 485,
      type: 'COMPUTED',
      value:
        '3048582568667961163458591044719888970457615373696260889510895468384152088691177363398736428772941378085768487423248655171335913749304966119424',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 486,
      type: 'COMPUTED',
      value:
        '6097165137335922326917182089439777940915230747392521779021790936768304177382354726797472857545882756171536974846497310342671827498609932238848',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 487,
      type: 'COMPUTED',
      value:
        '12194330274671844653834364178879555881830461494785043558043581873536608354764709453594945715091765512343073949692994620685343654997219864477696',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 488,
      type: 'COMPUTED',
      value:
        '24388660549343689307668728357759111763660922989570087116087163747073216709529418907189891430183531024686147899385989241370687309994439728955392',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 489,
      type: 'COMPUTED',
      value:
        '48777321098687378615337456715518223527321845979140174232174327494146433419058837814379782860367062049372295798771978482741374619988879457910784',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 490,
      type: 'COMPUTED',
      value:
        '97554642197374757230674913431036447054643691958280348464348654988292866838117675628759565720734124098744591597543956965482749239977758915821568',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 491,
      type: 'COMPUTED',
      value:
        '195109284394749514461349826862072894109287383916560696928697309976585733676235351257519131441468248197489183195087913930965498479955517831643136',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 492,
      type: 'COMPUTED',
      value:
        '390218568789499028922699653724145788218574767833121393857394619953171467352470702515038262882936496394978366390175827861930996959911035663286272',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 493,
      type: 'COMPUTED',
      value:
        '780437137578998057845399307448291576437149535666242787714789239906342934704941405030076525765872992789956732780351655723861993919822071326572544',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 494,
      type: 'COMPUTED',
      value:
        '1560874275157996115690798614896583152874299071332485575429578479812685869409882810060153051531745985579913465560703311447723987839644142653145088',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 495,
      type: 'COMPUTED',
      value:
        '3121748550315992231381597229793166305748598142664971150859156959625371738819765620120306103063491971159826931121406622895447975679288285306290176',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 496,
      type: 'COMPUTED',
      value:
        '6243497100631984462763194459586332611497196285329942301718313919250743477639531240240612206126983942319653862242813245790895951358576570612580352',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 497,
      type: 'COMPUTED',
      value:
        '12486994201263968925526388919172665222994392570659884603436627838501486955279062480481224412253967884639307724485626491581791902717153141225160704',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 498,
      type: 'COMPUTED',
      value:
        '24973988402527937851052777838345330445988785141319769206873255677002973910558124960962448824507935769278615448971252983163583805434306282450321408',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 499,
      type: 'COMPUTED',
      value:
        '49947976805055875702105555676690660891977570282639538413746511354005947821116249921924897649015871538557230897942505966327167610868612564900642816',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 500,
      type: 'COMPUTED',
      value:
        '99895953610111751404211111353381321783955140565279076827493022708011895642232499843849795298031743077114461795885011932654335221737225129801285632',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 501,
      type: 'COMPUTED',
      value:
        '199791907220223502808422222706762643567910281130558153654986045416023791284464999687699590596063486154228923591770023865308670443474450259602571264',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 502,
      type: 'COMPUTED',
      value:
        '399583814440447005616844445413525287135820562261116307309972090832047582568929999375399181192126972308457847183540047730617340886948900519205142528',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 503,
      type: 'COMPUTED',
      value:
        '799167628880894011233688890827050574271641124522232614619944181664095165137859998750798362384253944616915694367080095461234681773897801038410285056',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 504,
      type: 'COMPUTED',
      value:
        '1598335257761788022467377781654101148543282249044465229239888363328190330275719997501596724768507889233831388734160190922469363547795602076820570112',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 505,
      type: 'COMPUTED',
      value:
        '3196670515523576044934755563308202297086564498088930458479776726656380660551439995003193449537015778467662777468320381844938727095591204153641140224',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 506,
      type: 'COMPUTED',
      value:
        '6393341031047152089869511126616404594173128996177860916959553453312761321102879990006386899074031556935325554936640763689877454191182408307282280448',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 507,
      type: 'COMPUTED',
      value:
        '12786682062094304179739022253232809188346257992355721833919106906625522642205759980012773798148063113870651109873281527379754908382364816614564560896',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 508,
      type: 'COMPUTED',
      value:
        '25573364124188608359478044506465618376692515984711443667838213813251045284411519960025547596296126227741302219746563054759509816764729633229129121792',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 509,
      type: 'COMPUTED',
      value:
        '51146728248377216718956089012931236753385031969422887335676427626502090568823039920051095192592252455482604439493126109519019633529459266458258243584',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 510,
      type: 'COMPUTED',
      value:
        '102293456496754433437912178025862473506770063938845774671352855253004181137646079840102190385184504910965208878986252219038039267058918532916516487168',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 511,
      type: 'COMPUTED',
      value:
        '204586912993508866875824356051724947013540127877691549342705710506008362275292159680204380770369009821930417757972504438076078534117837065833032974336',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 512,
      type: 'COMPUTED',
      value:
        '409173825987017733751648712103449894027080255755383098685411421012016724550584319360408761540738019643860835515945008876152157068235674131666065948672',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 513,
      type: 'COMPUTED',
      value:
        '818347651974035467503297424206899788054160511510766197370822842024033449101168638720817523081476039287721671031890017752304314136471348263332131897344',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 0,
      y: 514,
      type: 'COMPUTED',
      value:
        '1636695303948070935006594848413799576108321023021532394741645684048066898202337277441635046162952078575443342063780035504608628272942696526664263794688',
      last_modified: '2022-07-06T17:30:08.174Z',
    },
    {
      x: 1,
      y: 11,
      type: 'PYTHON',
      value: '2',
      python_code: 'c(3, 11) * c(3, 10)\n',
      last_modified: '2022-07-06T17:10:41.480Z',
      python_output: '',
      array_cells: [],
      dependent_cells: [
        [3, 11],
        [3, 10],
      ],
    },
    {
      x: 1,
      y: 12,
      type: 'PYTHON',
      value: 'True',
      python_code: 'c(3, 11) == c(3, 10) + 1\n',
      last_modified: '2022-07-06T17:10:46.924Z',
      python_output: '',
      array_cells: [],
      dependent_cells: [
        [3, 11],
        [3, 10],
      ],
    },
    {
      x: 3,
      y: 9,
      type: 'TEXT',
      value: 'Ex Data',
      last_modified: '2022-07-06T17:10:35.948Z',
    },
    {
      x: 3,
      y: 10,
      type: 'TEXT',
      value: '1',
      last_modified: '2022-07-06T17:10:35.948Z',
    },
    {
      x: 3,
      y: 11,
      type: 'TEXT',
      value: '2',
      last_modified: '2022-07-06T17:10:35.948Z',
    },
    {
      x: 3,
      y: 12,
      type: 'TEXT',
      value: '3',
      last_modified: '2022-07-06T17:10:35.948Z',
    },
    {
      x: 5,
      y: 5,
      type: 'TEXT',
      value: 'Pandas Examples',
      last_modified: '2022-07-06T17:13:17.001Z',
    },
    {
      x: 5,
      y: 7,
      type: 'TEXT',
      value: 'Return a DataFrame to the grid',
      last_modified: '2022-07-06T17:18:36.278Z',
    },
    {
      x: 5,
      y: 8,
      type: 'PYTHON',
      value: '4',
      python_code:
        "import pandas as pd\nimport numpy as np\n\n# using numpy's randint\npd.DataFrame(np.random.randint(\n    0,\n    10,\n    size=(15, 4),\n))\n",
      last_modified: '2022-07-06T17:17:47.046Z',
      python_output: '',
      array_cells: [
        [5, 8],
        [6, 8],
        [7, 8],
        [8, 8],
        [5, 9],
        [6, 9],
        [7, 9],
        [8, 9],
        [5, 10],
        [6, 10],
        [7, 10],
        [8, 10],
        [5, 11],
        [6, 11],
        [7, 11],
        [8, 11],
        [5, 12],
        [6, 12],
        [7, 12],
        [8, 12],
        [5, 13],
        [6, 13],
        [7, 13],
        [8, 13],
        [5, 14],
        [6, 14],
        [7, 14],
        [8, 14],
        [5, 15],
        [6, 15],
        [7, 15],
        [8, 15],
        [5, 16],
        [6, 16],
        [7, 16],
        [8, 16],
        [5, 17],
        [6, 17],
        [7, 17],
        [8, 17],
        [5, 18],
        [6, 18],
        [7, 18],
        [8, 18],
        [5, 19],
        [6, 19],
        [7, 19],
        [8, 19],
        [5, 20],
        [6, 20],
        [7, 20],
        [8, 20],
        [5, 21],
        [6, 21],
        [7, 21],
        [8, 21],
        [5, 22],
        [6, 22],
        [7, 22],
        [8, 22],
      ],
    },
    {
      x: 5,
      y: 9,
      type: 'COMPUTED',
      value: '1',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 10,
      type: 'COMPUTED',
      value: '5',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 11,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 12,
      type: 'COMPUTED',
      value: '3',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 13,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 14,
      type: 'COMPUTED',
      value: '3',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 15,
      type: 'COMPUTED',
      value: '1',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 16,
      type: 'COMPUTED',
      value: '3',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 17,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 18,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 19,
      type: 'COMPUTED',
      value: '9',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 20,
      type: 'COMPUTED',
      value: '7',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 21,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 22,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 5,
      y: 24,
      type: 'TEXT',
      value: 'Reference a range of cells as a DataFrame',
      last_modified: '2022-07-06T17:18:42.760Z',
    },
    {
      x: 5,
      y: 25,
      type: 'PYTHON',
      value: '8',
      python_code:
        "df = getCells((5, 8), (8, 22))\n\ndf = df.astype('int64')\n\n# Multiply DF by 2 and return it to the grid\ndf * 2\n",
      last_modified: '2022-07-06T17:18:16.572Z',
      python_output: '',
      array_cells: [
        [5, 25],
        [6, 25],
        [7, 25],
        [8, 25],
        [5, 26],
        [6, 26],
        [7, 26],
        [8, 26],
        [5, 27],
        [6, 27],
        [7, 27],
        [8, 27],
        [5, 28],
        [6, 28],
        [7, 28],
        [8, 28],
        [5, 29],
        [6, 29],
        [7, 29],
        [8, 29],
        [5, 30],
        [6, 30],
        [7, 30],
        [8, 30],
        [5, 31],
        [6, 31],
        [7, 31],
        [8, 31],
        [5, 32],
        [6, 32],
        [7, 32],
        [8, 32],
        [5, 33],
        [6, 33],
        [7, 33],
        [8, 33],
        [5, 34],
        [6, 34],
        [7, 34],
        [8, 34],
        [5, 35],
        [6, 35],
        [7, 35],
        [8, 35],
        [5, 36],
        [6, 36],
        [7, 36],
        [8, 36],
        [5, 37],
        [6, 37],
        [7, 37],
        [8, 37],
        [5, 38],
        [6, 38],
        [7, 38],
        [8, 38],
        [5, 39],
        [6, 39],
        [7, 39],
        [8, 39],
      ],
      dependent_cells: [
        [4, 3],
        [4, 4],
        [4, 5],
        [4, 6],
        [4, 7],
        [4, 8],
        [4, 9],
        [4, 10],
        [4, 11],
        [4, 12],
        [4, 13],
        [4, 14],
        [4, 15],
        [4, 16],
        [4, 17],
        [5, 3],
        [5, 4],
        [5, 5],
        [5, 6],
        [5, 7],
        [5, 8],
        [5, 9],
        [5, 10],
        [5, 11],
        [5, 12],
        [5, 13],
        [5, 14],
        [5, 15],
        [5, 16],
        [5, 17],
        [6, 3],
        [6, 4],
        [6, 5],
        [6, 6],
        [6, 7],
        [6, 8],
        [6, 9],
        [6, 10],
        [6, 11],
        [6, 12],
        [6, 13],
        [6, 14],
        [6, 15],
        [6, 16],
        [6, 17],
        [7, 3],
        [7, 4],
        [7, 5],
        [7, 6],
        [7, 7],
        [7, 8],
        [7, 9],
        [7, 10],
        [7, 11],
        [7, 12],
        [7, 13],
        [7, 14],
        [7, 15],
        [7, 16],
        [7, 17],
      ],
    },
    {
      x: 5,
      y: 26,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 5,
      y: 27,
      type: 'COMPUTED',
      value: '10',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 5,
      y: 28,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 5,
      y: 29,
      type: 'COMPUTED',
      value: '6',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 5,
      y: 30,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 5,
      y: 31,
      type: 'COMPUTED',
      value: '6',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 5,
      y: 32,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 5,
      y: 33,
      type: 'COMPUTED',
      value: '6',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 5,
      y: 34,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 5,
      y: 35,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 5,
      y: 36,
      type: 'COMPUTED',
      value: '18',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 5,
      y: 37,
      type: 'COMPUTED',
      value: '14',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 5,
      y: 38,
      type: 'COMPUTED',
      value: '8',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 5,
      y: 39,
      type: 'COMPUTED',
      value: '8',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 8,
      type: 'COMPUTED',
      value: '5',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 9,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 10,
      type: 'COMPUTED',
      value: '5',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 11,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 12,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 13,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 14,
      type: 'COMPUTED',
      value: '8',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 15,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 16,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 17,
      type: 'COMPUTED',
      value: '3',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 18,
      type: 'COMPUTED',
      value: '7',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 19,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 20,
      type: 'COMPUTED',
      value: '3',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 21,
      type: 'COMPUTED',
      value: '6',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 22,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 6,
      y: 25,
      type: 'COMPUTED',
      value: '10',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 26,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 27,
      type: 'COMPUTED',
      value: '10',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 28,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 29,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 30,
      type: 'COMPUTED',
      value: '8',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 31,
      type: 'COMPUTED',
      value: '16',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 32,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 33,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 34,
      type: 'COMPUTED',
      value: '6',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 35,
      type: 'COMPUTED',
      value: '14',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 36,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 37,
      type: 'COMPUTED',
      value: '6',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 38,
      type: 'COMPUTED',
      value: '12',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 6,
      y: 39,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 8,
      type: 'COMPUTED',
      value: '8',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 9,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 10,
      type: 'COMPUTED',
      value: '9',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 11,
      type: 'COMPUTED',
      value: '7',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 12,
      type: 'COMPUTED',
      value: '5',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 13,
      type: 'COMPUTED',
      value: '9',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 14,
      type: 'COMPUTED',
      value: '1',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 15,
      type: 'COMPUTED',
      value: '7',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 16,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 17,
      type: 'COMPUTED',
      value: '5',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 18,
      type: 'COMPUTED',
      value: '6',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 19,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 20,
      type: 'COMPUTED',
      value: '9',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 21,
      type: 'COMPUTED',
      value: '7',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 22,
      type: 'COMPUTED',
      value: '6',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 7,
      y: 25,
      type: 'COMPUTED',
      value: '16',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 26,
      type: 'COMPUTED',
      value: '8',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 27,
      type: 'COMPUTED',
      value: '18',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 28,
      type: 'COMPUTED',
      value: '14',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 29,
      type: 'COMPUTED',
      value: '10',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 30,
      type: 'COMPUTED',
      value: '18',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 31,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 32,
      type: 'COMPUTED',
      value: '14',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 33,
      type: 'COMPUTED',
      value: '8',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 34,
      type: 'COMPUTED',
      value: '10',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 35,
      type: 'COMPUTED',
      value: '12',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 36,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 37,
      type: 'COMPUTED',
      value: '18',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 38,
      type: 'COMPUTED',
      value: '14',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 7,
      y: 39,
      type: 'COMPUTED',
      value: '12',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 8,
      type: 'COMPUTED',
      value: '7',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 9,
      type: 'COMPUTED',
      value: '6',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 10,
      type: 'COMPUTED',
      value: '3',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 11,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 12,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 13,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 14,
      type: 'COMPUTED',
      value: '3',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 15,
      type: 'COMPUTED',
      value: '1',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 16,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 17,
      type: 'COMPUTED',
      value: '8',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 18,
      type: 'COMPUTED',
      value: '1',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 19,
      type: 'COMPUTED',
      value: '8',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 20,
      type: 'COMPUTED',
      value: '3',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 21,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 22,
      type: 'COMPUTED',
      value: '3',
      last_modified: '2022-07-06T17:17:47.046Z',
    },
    {
      x: 8,
      y: 25,
      type: 'COMPUTED',
      value: '14',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 26,
      type: 'COMPUTED',
      value: '12',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 27,
      type: 'COMPUTED',
      value: '6',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 28,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 29,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 30,
      type: 'COMPUTED',
      value: '8',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 31,
      type: 'COMPUTED',
      value: '6',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 32,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 33,
      type: 'COMPUTED',
      value: '4',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 34,
      type: 'COMPUTED',
      value: '16',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 35,
      type: 'COMPUTED',
      value: '2',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 36,
      type: 'COMPUTED',
      value: '16',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 37,
      type: 'COMPUTED',
      value: '6',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 38,
      type: 'COMPUTED',
      value: '0',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 8,
      y: 39,
      type: 'COMPUTED',
      value: '6',
      last_modified: '2022-07-06T17:18:16.572Z',
    },
    {
      x: 10,
      y: 5,
      type: 'TEXT',
      value: 'Advanced Examples',
      last_modified: '2022-07-06T17:19:19.636Z',
    },
    {
      x: 10,
      y: 7,
      type: 'TEXT',
      value: 'Make an API request',
      last_modified: '2022-07-06T17:19:25.780Z',
    },
    {
      x: 10,
      y: 8,
      type: 'TEXT',
      value: 'SNOW',
      last_modified: '2022-07-06T17:30:44.397Z',
    },
    {
      x: 10,
      y: 9,
      type: 'PYTHON',
      value: 'Full Name',
      python_code:
        // eslint-disable-next-line
        'from pprint import pprint\nimport pandas as pd\nimport json\nimport js\n\nsymbol = c(10, 8)\n\nstock_financials = await js.fetch(\'https://api.polygon.io/vX/reference/financials?ticker={}&apiKey=_xBCl_0zcb9H1W25jJEK5pQaQTVLtemL\'.format(symbol), {\n    "method": "GET",\n    "headers": {"Content-Type": "application/json"}\n})\nstock_financials_json = json.loads(await stock_financials.text())\nincome_statement = stock_financials_json["results"][0]["financials"]["income_statement"]\nrevenue = income_statement["revenues"]["value"]\n\n\nmarket_data = await js.fetch(\'https://api.polygon.io/v3/reference/tickers/{}?apiKey=_xBCl_0zcb9H1W25jJEK5pQaQTVLtemL\'.format(symbol), {\n    "method": "GET",\n    "headers": {"Content-Type": "application/json"}\n})\nmarket_data_json = json.loads(await market_data.text())["results"]\nmarket_cap = market_data_json["market_cap"]\nname = market_data_json["name"]\n\nresult = pd.DataFrame([[\n    name[:20],\n    "${:,}".format(int(revenue)),\n    "${:.2e}".format(market_cap),\n    "{:,.2f}".format(market_cap / revenue),\n]], columns=["Full Name", "Revenue", "Market Cap", "Mulitple"])\n',
      last_modified: '2022-07-06T17:30:45.195Z',
      python_output: '',
      array_cells: [
        [10, 9],
        [11, 9],
        [12, 9],
        [13, 9],
        [10, 10],
        [11, 10],
        [12, 10],
        [13, 10],
      ],
      dependent_cells: [[10, 8]],
    },
    {
      x: 10,
      y: 10,
      type: 'COMPUTED',
      value: 'Snowflake Inc.',
      last_modified: '2022-07-06T17:30:45.195Z',
    },
    {
      x: 10,
      y: 12,
      type: 'TEXT',
      value: 'Use Python packages from PIP',
      last_modified: '2022-07-06T17:23:04.545Z',
    },
    {
      x: 10,
      y: 13,
      type: 'TEXT',
      value: 'Generate a fake person using the Python package Faker',
      last_modified: '2022-07-06T17:27:59.094Z',
    },
    {
      x: 10,
      y: 14,
      type: 'PYTHON',
      value: 'Name',
      python_code:
        '# Run this cell again to generate a new fake person\n\nimport micropip\n\nawait micropip.install("faker")\n\nfrom faker import Faker\nfake = Faker()\n\n[\n    [\n        "Name"[:13],\n        "Birthday",\n        "SSN",\n        "Phone",\n        "Address"\n    ],\n    [\n        fake.name(),\n        str(fake.date_of_birth()),\n        fake.ssn(),\n        fake.phone_number()[:13],\n        fake.address()\n    ]\n]\n',
      last_modified: '2022-07-06T17:31:20.458Z',
      python_output: '',
      array_cells: [
        [10, 14],
        [11, 14],
        [12, 14],
        [13, 14],
        [14, 14],
        [10, 15],
        [11, 15],
        [12, 15],
        [13, 15],
        [14, 15],
      ],
      dependent_cells: [],
    },
    {
      x: 10,
      y: 15,
      type: 'COMPUTED',
      value: 'Tammie Young',
      last_modified: '2022-07-06T17:31:20.458Z',
    },
    {
      x: 11,
      y: 8,
      type: 'TEXT',
      value: '<- Try changing ticker',
      last_modified: '2022-07-06T17:19:47.583Z',
    },
    {
      x: 11,
      y: 9,
      type: 'COMPUTED',
      value: 'Revenue',
      last_modified: '2022-07-06T17:30:45.195Z',
    },
    {
      x: 11,
      y: 10,
      type: 'COMPUTED',
      value: '$422,371,000',
      last_modified: '2022-07-06T17:30:45.195Z',
    },
    {
      x: 11,
      y: 14,
      type: 'COMPUTED',
      value: 'Birthday',
      last_modified: '2022-07-06T17:31:20.458Z',
    },
    {
      x: 11,
      y: 15,
      type: 'COMPUTED',
      value: '2011-09-06',
      last_modified: '2022-07-06T17:31:20.458Z',
    },
    {
      x: 12,
      y: 9,
      type: 'COMPUTED',
      value: 'Market Cap',
      last_modified: '2022-07-06T17:30:45.195Z',
    },
    {
      x: 12,
      y: 10,
      type: 'COMPUTED',
      value: '$4.93e+10',
      last_modified: '2022-07-06T17:30:45.195Z',
    },
    {
      x: 12,
      y: 14,
      type: 'COMPUTED',
      value: 'SSN',
      last_modified: '2022-07-06T17:31:20.458Z',
    },
    {
      x: 12,
      y: 15,
      type: 'COMPUTED',
      value: '153-54-5901',
      last_modified: '2022-07-06T17:31:20.458Z',
    },
    {
      x: 13,
      y: 9,
      type: 'COMPUTED',
      value: 'Mulitple',
      last_modified: '2022-07-06T17:30:45.195Z',
    },
    {
      x: 13,
      y: 10,
      type: 'COMPUTED',
      value: '116.66',
      last_modified: '2022-07-06T17:30:45.195Z',
    },
    {
      x: 13,
      y: 14,
      type: 'COMPUTED',
      value: 'Phone',
      last_modified: '2022-07-06T17:31:20.458Z',
    },
    {
      x: 13,
      y: 15,
      type: 'COMPUTED',
      value: '(508)230-1472',
      last_modified: '2022-07-06T17:31:20.458Z',
    },
    {
      x: 14,
      y: 14,
      type: 'COMPUTED',
      value: 'Address',
      last_modified: '2022-07-06T17:31:20.458Z',
    },
    {
      x: 14,
      y: 15,
      type: 'COMPUTED',
      value: 'Unit 5104 Box 2516\nDPO AP 26457',
      last_modified: '2022-07-06T17:31:20.458Z',
    },
  ],
  dgraph:
    '{"vertices":{"dataType":"Map","value":[["4,3",null],["9,3",null],["4,4",null],["4,5",null],["4,6",null],["4,7",null],["4,8",null],["4,9",null],["4,10",null],["4,11",null],["4,12",null],["4,13",null],["4,14",null],["4,15",null],["4,16",null],["4,17",null],["5,3",null],["5,4",null],["5,5",null],["5,6",null],["5,7",null],["5,8",null],["5,9",null],["5,10",null],["5,11",null],["5,12",null],["5,13",null],["5,14",null],["5,15",null],["5,16",null],["5,17",null],["6,3",null],["6,4",null],["6,5",null],["6,6",null],["6,7",null],["6,8",null],["6,9",null],["6,10",null],["6,11",null],["6,12",null],["6,13",null],["6,14",null],["6,15",null],["6,16",null],["6,17",null],["7,3",null],["7,4",null],["7,5",null],["7,6",null],["7,7",null],["7,8",null],["7,9",null],["7,10",null],["7,11",null],["7,12",null],["7,13",null],["7,14",null],["7,15",null],["7,16",null],["7,17",null],["0,9",null],["2,9",null],["2,10",null],["0,10",null],["3,9",null],["3,11",null],["0,11",null],["3,10",null],["1,11",null],["1,12",null],["5,25",null],["5,18",null],["5,19",null],["5,20",null],["5,21",null],["5,22",null],["6,18",null],["6,19",null],["6,20",null],["6,21",null],["6,22",null],["7,18",null],["7,19",null],["7,20",null],["7,21",null],["7,22",null],["8,8",null],["8,9",null],["8,10",null],["8,11",null],["8,12",null],["8,13",null],["8,14",null],["8,15",null],["8,16",null],["8,17",null],["8,18",null],["8,19",null],["8,20",null],["8,21",null],["8,22",null],["10,8",null],["10,9",null],["0,15",null],["2,15",null],["0,16",null],["0,17",null],["0,18",null],["0,19",null],["0,20",null],["0,21",null],["0,22",null],["0,23",null],["0,24",null],["0,25",null],["0,26",null],["0,27",null],["0,28",null],["0,29",null],["0,30",null],["0,31",null],["0,32",null],["0,33",null],["0,34",null],["0,35",null],["0,36",null],["0,37",null],["0,38",null],["0,39",null],["0,40",null],["0,41",null],["0,42",null],["0,43",null],["0,44",null],["0,45",null],["0,46",null],["0,47",null],["0,48",null],["0,49",null],["0,50",null],["0,51",null],["0,52",null],["0,53",null],["0,54",null],["0,55",null],["0,56",null],["0,57",null],["0,58",null],["0,59",null],["0,60",null],["0,61",null],["0,62",null],["0,63",null],["0,64",null],["0,65",null],["0,66",null],["0,67",null],["0,68",null],["0,69",null],["0,70",null],["0,71",null],["0,72",null],["0,73",null],["0,74",null],["0,75",null],["0,76",null],["0,77",null],["0,78",null],["0,79",null],["0,80",null],["0,81",null],["0,82",null],["0,83",null],["0,84",null],["0,85",null],["0,86",null],["0,87",null],["0,88",null],["0,89",null],["0,90",null],["0,91",null],["0,92",null],["0,93",null],["0,94",null],["0,95",null],["0,96",null],["0,97",null],["0,98",null],["0,99",null],["0,100",null],["0,101",null],["0,102",null],["0,103",null],["0,104",null],["0,105",null],["0,106",null],["0,107",null],["0,108",null],["0,109",null],["0,110",null],["0,111",null],["0,112",null],["0,113",null],["0,114",null],["0,115",null],["0,116",null],["0,117",null],["0,118",null],["0,119",null],["0,120",null],["0,121",null],["0,122",null],["0,123",null],["0,124",null],["0,125",null],["0,126",null],["0,127",null],["0,128",null],["0,129",null],["0,130",null],["0,131",null],["0,132",null],["0,133",null],["0,134",null],["0,135",null],["0,136",null],["0,137",null],["0,138",null],["0,139",null],["0,140",null],["0,141",null],["0,142",null],["0,143",null],["0,144",null],["0,145",null],["0,146",null],["0,147",null],["0,148",null],["0,149",null],["0,150",null],["0,151",null],["0,152",null],["0,153",null],["0,154",null],["0,155",null],["0,156",null],["0,157",null],["0,158",null],["0,159",null],["0,160",null],["0,161",null],["0,162",null],["0,163",null],["0,164",null],["0,165",null],["0,166",null],["0,167",null],["0,168",null],["0,169",null],["0,170",null],["0,171",null],["0,172",null],["0,173",null],["0,174",null],["0,175",null],["0,176",null],["0,177",null],["0,178",null],["0,179",null],["0,180",null],["0,181",null],["0,182",null],["0,183",null],["0,184",null],["0,185",null],["0,186",null],["0,187",null],["0,188",null],["0,189",null],["0,190",null],["0,191",null],["0,192",null],["0,193",null],["0,194",null],["0,195",null],["0,196",null],["0,197",null],["0,198",null],["0,199",null],["0,200",null],["0,201",null],["0,202",null],["0,203",null],["0,204",null],["0,205",null],["0,206",null],["0,207",null],["0,208",null],["0,209",null],["0,210",null],["0,211",null],["0,212",null],["0,213",null],["0,214",null],["0,215",null],["0,216",null],["0,217",null],["0,218",null],["0,219",null],["0,220",null],["0,221",null],["0,222",null],["0,223",null],["0,224",null],["0,225",null],["0,226",null],["0,227",null],["0,228",null],["0,229",null],["0,230",null],["0,231",null],["0,232",null],["0,233",null],["0,234",null],["0,235",null],["0,236",null],["0,237",null],["0,238",null],["0,239",null],["0,240",null],["0,241",null],["0,242",null],["0,243",null],["0,244",null],["0,245",null],["0,246",null],["0,247",null],["0,248",null],["0,249",null],["0,250",null],["0,251",null],["0,252",null],["0,253",null],["0,254",null],["0,255",null],["0,256",null],["0,257",null],["0,258",null],["0,259",null],["0,260",null],["0,261",null],["0,262",null],["0,263",null],["0,264",null],["0,265",null],["0,266",null],["0,267",null],["0,268",null],["0,269",null],["0,270",null],["0,271",null],["0,272",null],["0,273",null],["0,274",null],["0,275",null],["0,276",null],["0,277",null],["0,278",null],["0,279",null],["0,280",null],["0,281",null],["0,282",null],["0,283",null],["0,284",null],["0,285",null],["0,286",null],["0,287",null],["0,288",null],["0,289",null],["0,290",null],["0,291",null],["0,292",null],["0,293",null],["0,294",null],["0,295",null],["0,296",null],["0,297",null],["0,298",null],["0,299",null],["0,300",null],["0,301",null],["0,302",null],["0,303",null],["0,304",null],["0,305",null],["0,306",null],["0,307",null],["0,308",null],["0,309",null],["0,310",null],["0,311",null],["0,312",null],["0,313",null],["0,314",null],["0,315",null],["0,316",null],["0,317",null],["0,318",null],["0,319",null],["0,320",null],["0,321",null],["0,322",null],["0,323",null],["0,324",null],["0,325",null],["0,326",null],["0,327",null],["0,328",null],["0,329",null],["0,330",null],["0,331",null],["0,332",null],["0,333",null],["0,334",null],["0,335",null],["0,336",null],["0,337",null],["0,338",null],["0,339",null],["0,340",null],["0,341",null],["0,342",null],["0,343",null],["0,344",null],["0,345",null],["0,346",null],["0,347",null],["0,348",null],["0,349",null],["0,350",null],["0,351",null],["0,352",null],["0,353",null],["0,354",null],["0,355",null],["0,356",null],["0,357",null],["0,358",null],["0,359",null],["0,360",null],["0,361",null],["0,362",null],["0,363",null],["0,364",null],["0,365",null],["0,366",null],["0,367",null],["0,368",null],["0,369",null],["0,370",null],["0,371",null],["0,372",null],["0,373",null],["0,374",null],["0,375",null],["0,376",null],["0,377",null],["0,378",null],["0,379",null],["0,380",null],["0,381",null],["0,382",null],["0,383",null],["0,384",null],["0,385",null],["0,386",null],["0,387",null],["0,388",null],["0,389",null],["0,390",null],["0,391",null],["0,392",null],["0,393",null],["0,394",null],["0,395",null],["0,396",null],["0,397",null],["0,398",null],["0,399",null],["0,400",null],["0,401",null],["0,402",null],["0,403",null],["0,404",null],["0,405",null],["0,406",null],["0,407",null],["0,408",null],["0,409",null],["0,410",null],["0,411",null],["0,412",null],["0,413",null],["0,414",null],["0,415",null],["0,416",null],["0,417",null],["0,418",null],["0,419",null],["0,420",null],["0,421",null],["0,422",null],["0,423",null],["0,424",null],["0,425",null],["0,426",null],["0,427",null],["0,428",null],["0,429",null],["0,430",null],["0,431",null],["0,432",null],["0,433",null],["0,434",null],["0,435",null],["0,436",null],["0,437",null],["0,438",null],["0,439",null],["0,440",null],["0,441",null],["0,442",null],["0,443",null],["0,444",null],["0,445",null],["0,446",null],["0,447",null],["0,448",null],["0,449",null],["0,450",null],["0,451",null],["0,452",null],["0,453",null],["0,454",null],["0,455",null],["0,456",null],["0,457",null],["0,458",null],["0,459",null],["0,460",null],["0,461",null],["0,462",null],["0,463",null],["0,464",null],["0,465",null],["0,466",null],["0,467",null],["0,468",null],["0,469",null],["0,470",null],["0,471",null],["0,472",null],["0,473",null],["0,474",null],["0,475",null],["0,476",null],["0,477",null],["0,478",null],["0,479",null],["0,480",null],["0,481",null],["0,482",null],["0,483",null],["0,484",null],["0,485",null],["0,486",null],["0,487",null],["0,488",null],["0,489",null],["0,490",null],["0,491",null],["0,492",null],["0,493",null],["0,494",null],["0,495",null],["0,496",null],["0,497",null],["0,498",null],["0,499",null],["0,500",null],["0,501",null],["0,502",null],["0,503",null],["0,504",null],["0,505",null],["0,506",null],["0,507",null],["0,508",null],["0,509",null],["0,510",null],["0,511",null],["0,512",null],["0,513",null],["0,514",null]]},"edges":{"dataType":"Map","value":[["4,3",{"dataType":"Map","value":[["9,3",1]]}],["9,3",{"dataType":"Map","value":[]}],["4,4",{"dataType":"Map","value":[["9,3",1]]}],["4,5",{"dataType":"Map","value":[["9,3",1]]}],["4,6",{"dataType":"Map","value":[["9,3",1]]}],["4,7",{"dataType":"Map","value":[["9,3",1]]}],["4,8",{"dataType":"Map","value":[["9,3",1]]}],["4,9",{"dataType":"Map","value":[["9,3",1]]}],["4,10",{"dataType":"Map","value":[["9,3",1]]}],["4,11",{"dataType":"Map","value":[["9,3",1]]}],["4,12",{"dataType":"Map","value":[["9,3",1]]}],["4,13",{"dataType":"Map","value":[["9,3",1]]}],["4,14",{"dataType":"Map","value":[["9,3",1]]}],["4,15",{"dataType":"Map","value":[["9,3",1]]}],["4,16",{"dataType":"Map","value":[["9,3",1]]}],["4,17",{"dataType":"Map","value":[["9,3",1]]}],["5,3",{"dataType":"Map","value":[["9,3",1]]}],["5,4",{"dataType":"Map","value":[["9,3",1]]}],["5,5",{"dataType":"Map","value":[["9,3",1]]}],["5,6",{"dataType":"Map","value":[["9,3",1]]}],["5,7",{"dataType":"Map","value":[["9,3",1]]}],["5,8",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["5,9",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["5,10",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["5,11",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["5,12",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["5,13",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["5,14",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["5,15",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["5,16",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["5,17",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["6,3",{"dataType":"Map","value":[["9,3",1]]}],["6,4",{"dataType":"Map","value":[["9,3",1]]}],["6,5",{"dataType":"Map","value":[["9,3",1]]}],["6,6",{"dataType":"Map","value":[["9,3",1]]}],["6,7",{"dataType":"Map","value":[["9,3",1]]}],["6,8",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["6,9",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["6,10",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["6,11",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["6,12",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["6,13",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["6,14",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["6,15",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["6,16",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["6,17",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["7,3",{"dataType":"Map","value":[["9,3",1]]}],["7,4",{"dataType":"Map","value":[["9,3",1]]}],["7,5",{"dataType":"Map","value":[["9,3",1]]}],["7,6",{"dataType":"Map","value":[["9,3",1]]}],["7,7",{"dataType":"Map","value":[["9,3",1]]}],["7,8",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["7,9",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["7,10",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["7,11",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["7,12",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["7,13",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["7,14",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["7,15",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["7,16",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["7,17",{"dataType":"Map","value":[["9,3",1],["5,25",1]]}],["0,9",{"dataType":"Map","value":[["2,9",1]]}],["2,9",{"dataType":"Map","value":[["2,10",1]]}],["2,10",{"dataType":"Map","value":[]}],["0,10",{"dataType":"Map","value":[["2,10",1]]}],["3,9",{"dataType":"Map","value":[["0,9",1]]}],["3,11",{"dataType":"Map","value":[["0,11",1],["1,11",1],["1,12",1]]}],["0,11",{"dataType":"Map","value":[]}],["3,10",{"dataType":"Map","value":[["0,11",1],["1,11",1],["1,12",1]]}],["1,11",{"dataType":"Map","value":[]}],["1,12",{"dataType":"Map","value":[]}],["5,25",{"dataType":"Map","value":[]}],["5,18",{"dataType":"Map","value":[["5,25",1]]}],["5,19",{"dataType":"Map","value":[["5,25",1]]}],["5,20",{"dataType":"Map","value":[["5,25",1]]}],["5,21",{"dataType":"Map","value":[["5,25",1]]}],["5,22",{"dataType":"Map","value":[["5,25",1]]}],["6,18",{"dataType":"Map","value":[["5,25",1]]}],["6,19",{"dataType":"Map","value":[["5,25",1]]}],["6,20",{"dataType":"Map","value":[["5,25",1]]}],["6,21",{"dataType":"Map","value":[["5,25",1]]}],["6,22",{"dataType":"Map","value":[["5,25",1]]}],["7,18",{"dataType":"Map","value":[["5,25",1]]}],["7,19",{"dataType":"Map","value":[["5,25",1]]}],["7,20",{"dataType":"Map","value":[["5,25",1]]}],["7,21",{"dataType":"Map","value":[["5,25",1]]}],["7,22",{"dataType":"Map","value":[["5,25",1]]}],["8,8",{"dataType":"Map","value":[["5,25",1]]}],["8,9",{"dataType":"Map","value":[["5,25",1]]}],["8,10",{"dataType":"Map","value":[["5,25",1]]}],["8,11",{"dataType":"Map","value":[["5,25",1]]}],["8,12",{"dataType":"Map","value":[["5,25",1]]}],["8,13",{"dataType":"Map","value":[["5,25",1]]}],["8,14",{"dataType":"Map","value":[["5,25",1]]}],["8,15",{"dataType":"Map","value":[["5,25",1]]}],["8,16",{"dataType":"Map","value":[["5,25",1]]}],["8,17",{"dataType":"Map","value":[["5,25",1]]}],["8,18",{"dataType":"Map","value":[["5,25",1]]}],["8,19",{"dataType":"Map","value":[["5,25",1]]}],["8,20",{"dataType":"Map","value":[["5,25",1]]}],["8,21",{"dataType":"Map","value":[["5,25",1]]}],["8,22",{"dataType":"Map","value":[["5,25",1]]}],["10,8",{"dataType":"Map","value":[["10,9",1]]}],["10,9",{"dataType":"Map","value":[]}],["0,15",{"dataType":"Map","value":[["2,15",1]]}],["2,15",{"dataType":"Map","value":[]}],["0,16",{"dataType":"Map","value":[["2,15",1]]}],["0,17",{"dataType":"Map","value":[["2,15",1]]}],["0,18",{"dataType":"Map","value":[["2,15",1]]}],["0,19",{"dataType":"Map","value":[["2,15",1]]}],["0,20",{"dataType":"Map","value":[["2,15",1]]}],["0,21",{"dataType":"Map","value":[["2,15",1]]}],["0,22",{"dataType":"Map","value":[["2,15",1]]}],["0,23",{"dataType":"Map","value":[["2,15",1]]}],["0,24",{"dataType":"Map","value":[["2,15",1]]}],["0,25",{"dataType":"Map","value":[["2,15",1]]}],["0,26",{"dataType":"Map","value":[["2,15",1]]}],["0,27",{"dataType":"Map","value":[["2,15",1]]}],["0,28",{"dataType":"Map","value":[["2,15",1]]}],["0,29",{"dataType":"Map","value":[["2,15",1]]}],["0,30",{"dataType":"Map","value":[["2,15",1]]}],["0,31",{"dataType":"Map","value":[["2,15",1]]}],["0,32",{"dataType":"Map","value":[["2,15",1]]}],["0,33",{"dataType":"Map","value":[["2,15",1]]}],["0,34",{"dataType":"Map","value":[["2,15",1]]}],["0,35",{"dataType":"Map","value":[["2,15",1]]}],["0,36",{"dataType":"Map","value":[["2,15",1]]}],["0,37",{"dataType":"Map","value":[["2,15",1]]}],["0,38",{"dataType":"Map","value":[["2,15",1]]}],["0,39",{"dataType":"Map","value":[["2,15",1]]}],["0,40",{"dataType":"Map","value":[["2,15",1]]}],["0,41",{"dataType":"Map","value":[["2,15",1]]}],["0,42",{"dataType":"Map","value":[["2,15",1]]}],["0,43",{"dataType":"Map","value":[["2,15",1]]}],["0,44",{"dataType":"Map","value":[["2,15",1]]}],["0,45",{"dataType":"Map","value":[["2,15",1]]}],["0,46",{"dataType":"Map","value":[["2,15",1]]}],["0,47",{"dataType":"Map","value":[["2,15",1]]}],["0,48",{"dataType":"Map","value":[["2,15",1]]}],["0,49",{"dataType":"Map","value":[["2,15",1]]}],["0,50",{"dataType":"Map","value":[["2,15",1]]}],["0,51",{"dataType":"Map","value":[["2,15",1]]}],["0,52",{"dataType":"Map","value":[["2,15",1]]}],["0,53",{"dataType":"Map","value":[["2,15",1]]}],["0,54",{"dataType":"Map","value":[["2,15",1]]}],["0,55",{"dataType":"Map","value":[["2,15",1]]}],["0,56",{"dataType":"Map","value":[["2,15",1]]}],["0,57",{"dataType":"Map","value":[["2,15",1]]}],["0,58",{"dataType":"Map","value":[["2,15",1]]}],["0,59",{"dataType":"Map","value":[["2,15",1]]}],["0,60",{"dataType":"Map","value":[["2,15",1]]}],["0,61",{"dataType":"Map","value":[["2,15",1]]}],["0,62",{"dataType":"Map","value":[["2,15",1]]}],["0,63",{"dataType":"Map","value":[["2,15",1]]}],["0,64",{"dataType":"Map","value":[["2,15",1]]}],["0,65",{"dataType":"Map","value":[["2,15",1]]}],["0,66",{"dataType":"Map","value":[["2,15",1]]}],["0,67",{"dataType":"Map","value":[["2,15",1]]}],["0,68",{"dataType":"Map","value":[["2,15",1]]}],["0,69",{"dataType":"Map","value":[["2,15",1]]}],["0,70",{"dataType":"Map","value":[["2,15",1]]}],["0,71",{"dataType":"Map","value":[["2,15",1]]}],["0,72",{"dataType":"Map","value":[["2,15",1]]}],["0,73",{"dataType":"Map","value":[["2,15",1]]}],["0,74",{"dataType":"Map","value":[["2,15",1]]}],["0,75",{"dataType":"Map","value":[["2,15",1]]}],["0,76",{"dataType":"Map","value":[["2,15",1]]}],["0,77",{"dataType":"Map","value":[["2,15",1]]}],["0,78",{"dataType":"Map","value":[["2,15",1]]}],["0,79",{"dataType":"Map","value":[["2,15",1]]}],["0,80",{"dataType":"Map","value":[["2,15",1]]}],["0,81",{"dataType":"Map","value":[["2,15",1]]}],["0,82",{"dataType":"Map","value":[["2,15",1]]}],["0,83",{"dataType":"Map","value":[["2,15",1]]}],["0,84",{"dataType":"Map","value":[["2,15",1]]}],["0,85",{"dataType":"Map","value":[["2,15",1]]}],["0,86",{"dataType":"Map","value":[["2,15",1]]}],["0,87",{"dataType":"Map","value":[["2,15",1]]}],["0,88",{"dataType":"Map","value":[["2,15",1]]}],["0,89",{"dataType":"Map","value":[["2,15",1]]}],["0,90",{"dataType":"Map","value":[["2,15",1]]}],["0,91",{"dataType":"Map","value":[["2,15",1]]}],["0,92",{"dataType":"Map","value":[["2,15",1]]}],["0,93",{"dataType":"Map","value":[["2,15",1]]}],["0,94",{"dataType":"Map","value":[["2,15",1]]}],["0,95",{"dataType":"Map","value":[["2,15",1]]}],["0,96",{"dataType":"Map","value":[["2,15",1]]}],["0,97",{"dataType":"Map","value":[["2,15",1]]}],["0,98",{"dataType":"Map","value":[["2,15",1]]}],["0,99",{"dataType":"Map","value":[["2,15",1]]}],["0,100",{"dataType":"Map","value":[["2,15",1]]}],["0,101",{"dataType":"Map","value":[["2,15",1]]}],["0,102",{"dataType":"Map","value":[["2,15",1]]}],["0,103",{"dataType":"Map","value":[["2,15",1]]}],["0,104",{"dataType":"Map","value":[["2,15",1]]}],["0,105",{"dataType":"Map","value":[["2,15",1]]}],["0,106",{"dataType":"Map","value":[["2,15",1]]}],["0,107",{"dataType":"Map","value":[["2,15",1]]}],["0,108",{"dataType":"Map","value":[["2,15",1]]}],["0,109",{"dataType":"Map","value":[["2,15",1]]}],["0,110",{"dataType":"Map","value":[["2,15",1]]}],["0,111",{"dataType":"Map","value":[["2,15",1]]}],["0,112",{"dataType":"Map","value":[["2,15",1]]}],["0,113",{"dataType":"Map","value":[["2,15",1]]}],["0,114",{"dataType":"Map","value":[["2,15",1]]}],["0,115",{"dataType":"Map","value":[["2,15",1]]}],["0,116",{"dataType":"Map","value":[["2,15",1]]}],["0,117",{"dataType":"Map","value":[["2,15",1]]}],["0,118",{"dataType":"Map","value":[["2,15",1]]}],["0,119",{"dataType":"Map","value":[["2,15",1]]}],["0,120",{"dataType":"Map","value":[["2,15",1]]}],["0,121",{"dataType":"Map","value":[["2,15",1]]}],["0,122",{"dataType":"Map","value":[["2,15",1]]}],["0,123",{"dataType":"Map","value":[["2,15",1]]}],["0,124",{"dataType":"Map","value":[["2,15",1]]}],["0,125",{"dataType":"Map","value":[["2,15",1]]}],["0,126",{"dataType":"Map","value":[["2,15",1]]}],["0,127",{"dataType":"Map","value":[["2,15",1]]}],["0,128",{"dataType":"Map","value":[["2,15",1]]}],["0,129",{"dataType":"Map","value":[["2,15",1]]}],["0,130",{"dataType":"Map","value":[["2,15",1]]}],["0,131",{"dataType":"Map","value":[["2,15",1]]}],["0,132",{"dataType":"Map","value":[["2,15",1]]}],["0,133",{"dataType":"Map","value":[["2,15",1]]}],["0,134",{"dataType":"Map","value":[["2,15",1]]}],["0,135",{"dataType":"Map","value":[["2,15",1]]}],["0,136",{"dataType":"Map","value":[["2,15",1]]}],["0,137",{"dataType":"Map","value":[["2,15",1]]}],["0,138",{"dataType":"Map","value":[["2,15",1]]}],["0,139",{"dataType":"Map","value":[["2,15",1]]}],["0,140",{"dataType":"Map","value":[["2,15",1]]}],["0,141",{"dataType":"Map","value":[["2,15",1]]}],["0,142",{"dataType":"Map","value":[["2,15",1]]}],["0,143",{"dataType":"Map","value":[["2,15",1]]}],["0,144",{"dataType":"Map","value":[["2,15",1]]}],["0,145",{"dataType":"Map","value":[["2,15",1]]}],["0,146",{"dataType":"Map","value":[["2,15",1]]}],["0,147",{"dataType":"Map","value":[["2,15",1]]}],["0,148",{"dataType":"Map","value":[["2,15",1]]}],["0,149",{"dataType":"Map","value":[["2,15",1]]}],["0,150",{"dataType":"Map","value":[["2,15",1]]}],["0,151",{"dataType":"Map","value":[["2,15",1]]}],["0,152",{"dataType":"Map","value":[["2,15",1]]}],["0,153",{"dataType":"Map","value":[["2,15",1]]}],["0,154",{"dataType":"Map","value":[["2,15",1]]}],["0,155",{"dataType":"Map","value":[["2,15",1]]}],["0,156",{"dataType":"Map","value":[["2,15",1]]}],["0,157",{"dataType":"Map","value":[["2,15",1]]}],["0,158",{"dataType":"Map","value":[["2,15",1]]}],["0,159",{"dataType":"Map","value":[["2,15",1]]}],["0,160",{"dataType":"Map","value":[["2,15",1]]}],["0,161",{"dataType":"Map","value":[["2,15",1]]}],["0,162",{"dataType":"Map","value":[["2,15",1]]}],["0,163",{"dataType":"Map","value":[["2,15",1]]}],["0,164",{"dataType":"Map","value":[["2,15",1]]}],["0,165",{"dataType":"Map","value":[["2,15",1]]}],["0,166",{"dataType":"Map","value":[["2,15",1]]}],["0,167",{"dataType":"Map","value":[["2,15",1]]}],["0,168",{"dataType":"Map","value":[["2,15",1]]}],["0,169",{"dataType":"Map","value":[["2,15",1]]}],["0,170",{"dataType":"Map","value":[["2,15",1]]}],["0,171",{"dataType":"Map","value":[["2,15",1]]}],["0,172",{"dataType":"Map","value":[["2,15",1]]}],["0,173",{"dataType":"Map","value":[["2,15",1]]}],["0,174",{"dataType":"Map","value":[["2,15",1]]}],["0,175",{"dataType":"Map","value":[["2,15",1]]}],["0,176",{"dataType":"Map","value":[["2,15",1]]}],["0,177",{"dataType":"Map","value":[["2,15",1]]}],["0,178",{"dataType":"Map","value":[["2,15",1]]}],["0,179",{"dataType":"Map","value":[["2,15",1]]}],["0,180",{"dataType":"Map","value":[["2,15",1]]}],["0,181",{"dataType":"Map","value":[["2,15",1]]}],["0,182",{"dataType":"Map","value":[["2,15",1]]}],["0,183",{"dataType":"Map","value":[["2,15",1]]}],["0,184",{"dataType":"Map","value":[["2,15",1]]}],["0,185",{"dataType":"Map","value":[["2,15",1]]}],["0,186",{"dataType":"Map","value":[["2,15",1]]}],["0,187",{"dataType":"Map","value":[["2,15",1]]}],["0,188",{"dataType":"Map","value":[["2,15",1]]}],["0,189",{"dataType":"Map","value":[["2,15",1]]}],["0,190",{"dataType":"Map","value":[["2,15",1]]}],["0,191",{"dataType":"Map","value":[["2,15",1]]}],["0,192",{"dataType":"Map","value":[["2,15",1]]}],["0,193",{"dataType":"Map","value":[["2,15",1]]}],["0,194",{"dataType":"Map","value":[["2,15",1]]}],["0,195",{"dataType":"Map","value":[["2,15",1]]}],["0,196",{"dataType":"Map","value":[["2,15",1]]}],["0,197",{"dataType":"Map","value":[["2,15",1]]}],["0,198",{"dataType":"Map","value":[["2,15",1]]}],["0,199",{"dataType":"Map","value":[["2,15",1]]}],["0,200",{"dataType":"Map","value":[["2,15",1]]}],["0,201",{"dataType":"Map","value":[["2,15",1]]}],["0,202",{"dataType":"Map","value":[["2,15",1]]}],["0,203",{"dataType":"Map","value":[["2,15",1]]}],["0,204",{"dataType":"Map","value":[["2,15",1]]}],["0,205",{"dataType":"Map","value":[["2,15",1]]}],["0,206",{"dataType":"Map","value":[["2,15",1]]}],["0,207",{"dataType":"Map","value":[["2,15",1]]}],["0,208",{"dataType":"Map","value":[["2,15",1]]}],["0,209",{"dataType":"Map","value":[["2,15",1]]}],["0,210",{"dataType":"Map","value":[["2,15",1]]}],["0,211",{"dataType":"Map","value":[["2,15",1]]}],["0,212",{"dataType":"Map","value":[["2,15",1]]}],["0,213",{"dataType":"Map","value":[["2,15",1]]}],["0,214",{"dataType":"Map","value":[["2,15",1]]}],["0,215",{"dataType":"Map","value":[["2,15",1]]}],["0,216",{"dataType":"Map","value":[["2,15",1]]}],["0,217",{"dataType":"Map","value":[["2,15",1]]}],["0,218",{"dataType":"Map","value":[["2,15",1]]}],["0,219",{"dataType":"Map","value":[["2,15",1]]}],["0,220",{"dataType":"Map","value":[["2,15",1]]}],["0,221",{"dataType":"Map","value":[["2,15",1]]}],["0,222",{"dataType":"Map","value":[["2,15",1]]}],["0,223",{"dataType":"Map","value":[["2,15",1]]}],["0,224",{"dataType":"Map","value":[["2,15",1]]}],["0,225",{"dataType":"Map","value":[["2,15",1]]}],["0,226",{"dataType":"Map","value":[["2,15",1]]}],["0,227",{"dataType":"Map","value":[["2,15",1]]}],["0,228",{"dataType":"Map","value":[["2,15",1]]}],["0,229",{"dataType":"Map","value":[["2,15",1]]}],["0,230",{"dataType":"Map","value":[["2,15",1]]}],["0,231",{"dataType":"Map","value":[["2,15",1]]}],["0,232",{"dataType":"Map","value":[["2,15",1]]}],["0,233",{"dataType":"Map","value":[["2,15",1]]}],["0,234",{"dataType":"Map","value":[["2,15",1]]}],["0,235",{"dataType":"Map","value":[["2,15",1]]}],["0,236",{"dataType":"Map","value":[["2,15",1]]}],["0,237",{"dataType":"Map","value":[["2,15",1]]}],["0,238",{"dataType":"Map","value":[["2,15",1]]}],["0,239",{"dataType":"Map","value":[["2,15",1]]}],["0,240",{"dataType":"Map","value":[["2,15",1]]}],["0,241",{"dataType":"Map","value":[["2,15",1]]}],["0,242",{"dataType":"Map","value":[["2,15",1]]}],["0,243",{"dataType":"Map","value":[["2,15",1]]}],["0,244",{"dataType":"Map","value":[["2,15",1]]}],["0,245",{"dataType":"Map","value":[["2,15",1]]}],["0,246",{"dataType":"Map","value":[["2,15",1]]}],["0,247",{"dataType":"Map","value":[["2,15",1]]}],["0,248",{"dataType":"Map","value":[["2,15",1]]}],["0,249",{"dataType":"Map","value":[["2,15",1]]}],["0,250",{"dataType":"Map","value":[["2,15",1]]}],["0,251",{"dataType":"Map","value":[["2,15",1]]}],["0,252",{"dataType":"Map","value":[["2,15",1]]}],["0,253",{"dataType":"Map","value":[["2,15",1]]}],["0,254",{"dataType":"Map","value":[["2,15",1]]}],["0,255",{"dataType":"Map","value":[["2,15",1]]}],["0,256",{"dataType":"Map","value":[["2,15",1]]}],["0,257",{"dataType":"Map","value":[["2,15",1]]}],["0,258",{"dataType":"Map","value":[["2,15",1]]}],["0,259",{"dataType":"Map","value":[["2,15",1]]}],["0,260",{"dataType":"Map","value":[["2,15",1]]}],["0,261",{"dataType":"Map","value":[["2,15",1]]}],["0,262",{"dataType":"Map","value":[["2,15",1]]}],["0,263",{"dataType":"Map","value":[["2,15",1]]}],["0,264",{"dataType":"Map","value":[["2,15",1]]}],["0,265",{"dataType":"Map","value":[["2,15",1]]}],["0,266",{"dataType":"Map","value":[["2,15",1]]}],["0,267",{"dataType":"Map","value":[["2,15",1]]}],["0,268",{"dataType":"Map","value":[["2,15",1]]}],["0,269",{"dataType":"Map","value":[["2,15",1]]}],["0,270",{"dataType":"Map","value":[["2,15",1]]}],["0,271",{"dataType":"Map","value":[["2,15",1]]}],["0,272",{"dataType":"Map","value":[["2,15",1]]}],["0,273",{"dataType":"Map","value":[["2,15",1]]}],["0,274",{"dataType":"Map","value":[["2,15",1]]}],["0,275",{"dataType":"Map","value":[["2,15",1]]}],["0,276",{"dataType":"Map","value":[["2,15",1]]}],["0,277",{"dataType":"Map","value":[["2,15",1]]}],["0,278",{"dataType":"Map","value":[["2,15",1]]}],["0,279",{"dataType":"Map","value":[["2,15",1]]}],["0,280",{"dataType":"Map","value":[["2,15",1]]}],["0,281",{"dataType":"Map","value":[["2,15",1]]}],["0,282",{"dataType":"Map","value":[["2,15",1]]}],["0,283",{"dataType":"Map","value":[["2,15",1]]}],["0,284",{"dataType":"Map","value":[["2,15",1]]}],["0,285",{"dataType":"Map","value":[["2,15",1]]}],["0,286",{"dataType":"Map","value":[["2,15",1]]}],["0,287",{"dataType":"Map","value":[["2,15",1]]}],["0,288",{"dataType":"Map","value":[["2,15",1]]}],["0,289",{"dataType":"Map","value":[["2,15",1]]}],["0,290",{"dataType":"Map","value":[["2,15",1]]}],["0,291",{"dataType":"Map","value":[["2,15",1]]}],["0,292",{"dataType":"Map","value":[["2,15",1]]}],["0,293",{"dataType":"Map","value":[["2,15",1]]}],["0,294",{"dataType":"Map","value":[["2,15",1]]}],["0,295",{"dataType":"Map","value":[["2,15",1]]}],["0,296",{"dataType":"Map","value":[["2,15",1]]}],["0,297",{"dataType":"Map","value":[["2,15",1]]}],["0,298",{"dataType":"Map","value":[["2,15",1]]}],["0,299",{"dataType":"Map","value":[["2,15",1]]}],["0,300",{"dataType":"Map","value":[["2,15",1]]}],["0,301",{"dataType":"Map","value":[["2,15",1]]}],["0,302",{"dataType":"Map","value":[["2,15",1]]}],["0,303",{"dataType":"Map","value":[["2,15",1]]}],["0,304",{"dataType":"Map","value":[["2,15",1]]}],["0,305",{"dataType":"Map","value":[["2,15",1]]}],["0,306",{"dataType":"Map","value":[["2,15",1]]}],["0,307",{"dataType":"Map","value":[["2,15",1]]}],["0,308",{"dataType":"Map","value":[["2,15",1]]}],["0,309",{"dataType":"Map","value":[["2,15",1]]}],["0,310",{"dataType":"Map","value":[["2,15",1]]}],["0,311",{"dataType":"Map","value":[["2,15",1]]}],["0,312",{"dataType":"Map","value":[["2,15",1]]}],["0,313",{"dataType":"Map","value":[["2,15",1]]}],["0,314",{"dataType":"Map","value":[["2,15",1]]}],["0,315",{"dataType":"Map","value":[["2,15",1]]}],["0,316",{"dataType":"Map","value":[["2,15",1]]}],["0,317",{"dataType":"Map","value":[["2,15",1]]}],["0,318",{"dataType":"Map","value":[["2,15",1]]}],["0,319",{"dataType":"Map","value":[["2,15",1]]}],["0,320",{"dataType":"Map","value":[["2,15",1]]}],["0,321",{"dataType":"Map","value":[["2,15",1]]}],["0,322",{"dataType":"Map","value":[["2,15",1]]}],["0,323",{"dataType":"Map","value":[["2,15",1]]}],["0,324",{"dataType":"Map","value":[["2,15",1]]}],["0,325",{"dataType":"Map","value":[["2,15",1]]}],["0,326",{"dataType":"Map","value":[["2,15",1]]}],["0,327",{"dataType":"Map","value":[["2,15",1]]}],["0,328",{"dataType":"Map","value":[["2,15",1]]}],["0,329",{"dataType":"Map","value":[["2,15",1]]}],["0,330",{"dataType":"Map","value":[["2,15",1]]}],["0,331",{"dataType":"Map","value":[["2,15",1]]}],["0,332",{"dataType":"Map","value":[["2,15",1]]}],["0,333",{"dataType":"Map","value":[["2,15",1]]}],["0,334",{"dataType":"Map","value":[["2,15",1]]}],["0,335",{"dataType":"Map","value":[["2,15",1]]}],["0,336",{"dataType":"Map","value":[["2,15",1]]}],["0,337",{"dataType":"Map","value":[["2,15",1]]}],["0,338",{"dataType":"Map","value":[["2,15",1]]}],["0,339",{"dataType":"Map","value":[["2,15",1]]}],["0,340",{"dataType":"Map","value":[["2,15",1]]}],["0,341",{"dataType":"Map","value":[["2,15",1]]}],["0,342",{"dataType":"Map","value":[["2,15",1]]}],["0,343",{"dataType":"Map","value":[["2,15",1]]}],["0,344",{"dataType":"Map","value":[["2,15",1]]}],["0,345",{"dataType":"Map","value":[["2,15",1]]}],["0,346",{"dataType":"Map","value":[["2,15",1]]}],["0,347",{"dataType":"Map","value":[["2,15",1]]}],["0,348",{"dataType":"Map","value":[["2,15",1]]}],["0,349",{"dataType":"Map","value":[["2,15",1]]}],["0,350",{"dataType":"Map","value":[["2,15",1]]}],["0,351",{"dataType":"Map","value":[["2,15",1]]}],["0,352",{"dataType":"Map","value":[["2,15",1]]}],["0,353",{"dataType":"Map","value":[["2,15",1]]}],["0,354",{"dataType":"Map","value":[["2,15",1]]}],["0,355",{"dataType":"Map","value":[["2,15",1]]}],["0,356",{"dataType":"Map","value":[["2,15",1]]}],["0,357",{"dataType":"Map","value":[["2,15",1]]}],["0,358",{"dataType":"Map","value":[["2,15",1]]}],["0,359",{"dataType":"Map","value":[["2,15",1]]}],["0,360",{"dataType":"Map","value":[["2,15",1]]}],["0,361",{"dataType":"Map","value":[["2,15",1]]}],["0,362",{"dataType":"Map","value":[["2,15",1]]}],["0,363",{"dataType":"Map","value":[["2,15",1]]}],["0,364",{"dataType":"Map","value":[["2,15",1]]}],["0,365",{"dataType":"Map","value":[["2,15",1]]}],["0,366",{"dataType":"Map","value":[["2,15",1]]}],["0,367",{"dataType":"Map","value":[["2,15",1]]}],["0,368",{"dataType":"Map","value":[["2,15",1]]}],["0,369",{"dataType":"Map","value":[["2,15",1]]}],["0,370",{"dataType":"Map","value":[["2,15",1]]}],["0,371",{"dataType":"Map","value":[["2,15",1]]}],["0,372",{"dataType":"Map","value":[["2,15",1]]}],["0,373",{"dataType":"Map","value":[["2,15",1]]}],["0,374",{"dataType":"Map","value":[["2,15",1]]}],["0,375",{"dataType":"Map","value":[["2,15",1]]}],["0,376",{"dataType":"Map","value":[["2,15",1]]}],["0,377",{"dataType":"Map","value":[["2,15",1]]}],["0,378",{"dataType":"Map","value":[["2,15",1]]}],["0,379",{"dataType":"Map","value":[["2,15",1]]}],["0,380",{"dataType":"Map","value":[["2,15",1]]}],["0,381",{"dataType":"Map","value":[["2,15",1]]}],["0,382",{"dataType":"Map","value":[["2,15",1]]}],["0,383",{"dataType":"Map","value":[["2,15",1]]}],["0,384",{"dataType":"Map","value":[["2,15",1]]}],["0,385",{"dataType":"Map","value":[["2,15",1]]}],["0,386",{"dataType":"Map","value":[["2,15",1]]}],["0,387",{"dataType":"Map","value":[["2,15",1]]}],["0,388",{"dataType":"Map","value":[["2,15",1]]}],["0,389",{"dataType":"Map","value":[["2,15",1]]}],["0,390",{"dataType":"Map","value":[["2,15",1]]}],["0,391",{"dataType":"Map","value":[["2,15",1]]}],["0,392",{"dataType":"Map","value":[["2,15",1]]}],["0,393",{"dataType":"Map","value":[["2,15",1]]}],["0,394",{"dataType":"Map","value":[["2,15",1]]}],["0,395",{"dataType":"Map","value":[["2,15",1]]}],["0,396",{"dataType":"Map","value":[["2,15",1]]}],["0,397",{"dataType":"Map","value":[["2,15",1]]}],["0,398",{"dataType":"Map","value":[["2,15",1]]}],["0,399",{"dataType":"Map","value":[["2,15",1]]}],["0,400",{"dataType":"Map","value":[["2,15",1]]}],["0,401",{"dataType":"Map","value":[["2,15",1]]}],["0,402",{"dataType":"Map","value":[["2,15",1]]}],["0,403",{"dataType":"Map","value":[["2,15",1]]}],["0,404",{"dataType":"Map","value":[["2,15",1]]}],["0,405",{"dataType":"Map","value":[["2,15",1]]}],["0,406",{"dataType":"Map","value":[["2,15",1]]}],["0,407",{"dataType":"Map","value":[["2,15",1]]}],["0,408",{"dataType":"Map","value":[["2,15",1]]}],["0,409",{"dataType":"Map","value":[["2,15",1]]}],["0,410",{"dataType":"Map","value":[["2,15",1]]}],["0,411",{"dataType":"Map","value":[["2,15",1]]}],["0,412",{"dataType":"Map","value":[["2,15",1]]}],["0,413",{"dataType":"Map","value":[["2,15",1]]}],["0,414",{"dataType":"Map","value":[["2,15",1]]}],["0,415",{"dataType":"Map","value":[["2,15",1]]}],["0,416",{"dataType":"Map","value":[["2,15",1]]}],["0,417",{"dataType":"Map","value":[["2,15",1]]}],["0,418",{"dataType":"Map","value":[["2,15",1]]}],["0,419",{"dataType":"Map","value":[["2,15",1]]}],["0,420",{"dataType":"Map","value":[["2,15",1]]}],["0,421",{"dataType":"Map","value":[["2,15",1]]}],["0,422",{"dataType":"Map","value":[["2,15",1]]}],["0,423",{"dataType":"Map","value":[["2,15",1]]}],["0,424",{"dataType":"Map","value":[["2,15",1]]}],["0,425",{"dataType":"Map","value":[["2,15",1]]}],["0,426",{"dataType":"Map","value":[["2,15",1]]}],["0,427",{"dataType":"Map","value":[["2,15",1]]}],["0,428",{"dataType":"Map","value":[["2,15",1]]}],["0,429",{"dataType":"Map","value":[["2,15",1]]}],["0,430",{"dataType":"Map","value":[["2,15",1]]}],["0,431",{"dataType":"Map","value":[["2,15",1]]}],["0,432",{"dataType":"Map","value":[["2,15",1]]}],["0,433",{"dataType":"Map","value":[["2,15",1]]}],["0,434",{"dataType":"Map","value":[["2,15",1]]}],["0,435",{"dataType":"Map","value":[["2,15",1]]}],["0,436",{"dataType":"Map","value":[["2,15",1]]}],["0,437",{"dataType":"Map","value":[["2,15",1]]}],["0,438",{"dataType":"Map","value":[["2,15",1]]}],["0,439",{"dataType":"Map","value":[["2,15",1]]}],["0,440",{"dataType":"Map","value":[["2,15",1]]}],["0,441",{"dataType":"Map","value":[["2,15",1]]}],["0,442",{"dataType":"Map","value":[["2,15",1]]}],["0,443",{"dataType":"Map","value":[["2,15",1]]}],["0,444",{"dataType":"Map","value":[["2,15",1]]}],["0,445",{"dataType":"Map","value":[["2,15",1]]}],["0,446",{"dataType":"Map","value":[["2,15",1]]}],["0,447",{"dataType":"Map","value":[["2,15",1]]}],["0,448",{"dataType":"Map","value":[["2,15",1]]}],["0,449",{"dataType":"Map","value":[["2,15",1]]}],["0,450",{"dataType":"Map","value":[["2,15",1]]}],["0,451",{"dataType":"Map","value":[["2,15",1]]}],["0,452",{"dataType":"Map","value":[["2,15",1]]}],["0,453",{"dataType":"Map","value":[["2,15",1]]}],["0,454",{"dataType":"Map","value":[["2,15",1]]}],["0,455",{"dataType":"Map","value":[["2,15",1]]}],["0,456",{"dataType":"Map","value":[["2,15",1]]}],["0,457",{"dataType":"Map","value":[["2,15",1]]}],["0,458",{"dataType":"Map","value":[["2,15",1]]}],["0,459",{"dataType":"Map","value":[["2,15",1]]}],["0,460",{"dataType":"Map","value":[["2,15",1]]}],["0,461",{"dataType":"Map","value":[["2,15",1]]}],["0,462",{"dataType":"Map","value":[["2,15",1]]}],["0,463",{"dataType":"Map","value":[["2,15",1]]}],["0,464",{"dataType":"Map","value":[["2,15",1]]}],["0,465",{"dataType":"Map","value":[["2,15",1]]}],["0,466",{"dataType":"Map","value":[["2,15",1]]}],["0,467",{"dataType":"Map","value":[["2,15",1]]}],["0,468",{"dataType":"Map","value":[["2,15",1]]}],["0,469",{"dataType":"Map","value":[["2,15",1]]}],["0,470",{"dataType":"Map","value":[["2,15",1]]}],["0,471",{"dataType":"Map","value":[["2,15",1]]}],["0,472",{"dataType":"Map","value":[["2,15",1]]}],["0,473",{"dataType":"Map","value":[["2,15",1]]}],["0,474",{"dataType":"Map","value":[["2,15",1]]}],["0,475",{"dataType":"Map","value":[["2,15",1]]}],["0,476",{"dataType":"Map","value":[["2,15",1]]}],["0,477",{"dataType":"Map","value":[["2,15",1]]}],["0,478",{"dataType":"Map","value":[["2,15",1]]}],["0,479",{"dataType":"Map","value":[["2,15",1]]}],["0,480",{"dataType":"Map","value":[["2,15",1]]}],["0,481",{"dataType":"Map","value":[["2,15",1]]}],["0,482",{"dataType":"Map","value":[["2,15",1]]}],["0,483",{"dataType":"Map","value":[["2,15",1]]}],["0,484",{"dataType":"Map","value":[["2,15",1]]}],["0,485",{"dataType":"Map","value":[["2,15",1]]}],["0,486",{"dataType":"Map","value":[["2,15",1]]}],["0,487",{"dataType":"Map","value":[["2,15",1]]}],["0,488",{"dataType":"Map","value":[["2,15",1]]}],["0,489",{"dataType":"Map","value":[["2,15",1]]}],["0,490",{"dataType":"Map","value":[["2,15",1]]}],["0,491",{"dataType":"Map","value":[["2,15",1]]}],["0,492",{"dataType":"Map","value":[["2,15",1]]}],["0,493",{"dataType":"Map","value":[["2,15",1]]}],["0,494",{"dataType":"Map","value":[["2,15",1]]}],["0,495",{"dataType":"Map","value":[["2,15",1]]}],["0,496",{"dataType":"Map","value":[["2,15",1]]}],["0,497",{"dataType":"Map","value":[["2,15",1]]}],["0,498",{"dataType":"Map","value":[["2,15",1]]}],["0,499",{"dataType":"Map","value":[["2,15",1]]}],["0,500",{"dataType":"Map","value":[["2,15",1]]}],["0,501",{"dataType":"Map","value":[["2,15",1]]}],["0,502",{"dataType":"Map","value":[["2,15",1]]}],["0,503",{"dataType":"Map","value":[["2,15",1]]}],["0,504",{"dataType":"Map","value":[["2,15",1]]}],["0,505",{"dataType":"Map","value":[["2,15",1]]}],["0,506",{"dataType":"Map","value":[["2,15",1]]}],["0,507",{"dataType":"Map","value":[["2,15",1]]}],["0,508",{"dataType":"Map","value":[["2,15",1]]}],["0,509",{"dataType":"Map","value":[["2,15",1]]}],["0,510",{"dataType":"Map","value":[["2,15",1]]}],["0,511",{"dataType":"Map","value":[["2,15",1]]}],["0,512",{"dataType":"Map","value":[["2,15",1]]}],["0,513",{"dataType":"Map","value":[["2,15",1]]}],["0,514",{"dataType":"Map","value":[["2,15",1]]}]]},"edgesCount":909}',
};
